import React, { Component, createRef } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import Fishing from "./fising";
import Sport from "./sport";
import TextSlider from "./textslide";
import Afficiate from "./affiliate";
import Signin from "./signin";
import Register from "./register";
import Loss from "./loss";
import Luckywhell from "./luckyfortune";
import Checkindaily from "./checkin";
import Cardminigame from "./cardminigame";
import LuckyWheelPage from "./luckywheelpage";
import Promotion from "./promotionx";
// import { isMobile } from 'react-device-detect';
import Profile from "./profile";
import Statement from "./statement";
import Banner from "./banner";
import MoblieMenu from "./mobilemenu";
import Mainindex from "./mainindex";
import Lowmenu from "./lowmenu";
import Popup from "./popup";
// import Lotto from "./lotto";
import Listgameall from "./linklistall";
// import GameHit from "./gamehit";
import moment from 'moment';
import md5 from 'md5';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NProgress from "nprogress";
import axios from 'axios';
import io from "socket.io-client";
import Rewards from "./rewards";
import Rank from "./rank";



let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ios: true,
            finish: 0,
            tabselectselect: 1,
            webnamexback: "",
            dateselect: moment(new Date()).format("YYYY/MM/DD"),
            inputTimeHour: moment(new Date()).format("HH"),
            inputTimeMin: moment(new Date()).format("mm"),
            isUploading: false,
            webname: "",
            previewUrl: null,
            usercheck: "",
            categorylist: [],
            isPopupOpen: false,
            selectedItem: null, // Store the selected item
            luckywheeldisplay: false,
            listitallgame: [],
            slotlist: [],
            sportlist: [],
            logoimg: window.localStorage.getItem('homeLogo') || '',
            describemain: "",
            fishinglist: [],
            gamehitlist: [],
            files: [],
            providorlist: [],
            filterlist: [],
            stats: {},
            isConfirmed: false,
            reports: {},
            qrstep: 1,
            listacc: [],
            addhome: true,
            whellsetting: [],
            pglist: [],
            tabselectdeposit: 0,
            rewardlist: [],
            loader: false,
            slotlist: [],
            recentlist: [],
            activePage: 1,
            ThmeseV: null,
            pagecount: 1,
            trueaccount: true,
            products_page_count: 1,
            isActive: false,
            resetpass: 0,
            paymentlist: null,
            checkcredit: false,
            refer: 1,
            showmodal: false,
            historylist: [],
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            afficiate: [],
            cashoutSet: [],
            modal: false,
            modalpromotion: false,
            linkaff: "",
            point: 0,
            maxwithdrawstatus: 0,
            useradvice: [],
            afficiatetoday: [],
            afficiateall: [],
            balance: 0,
            counter: 300,
            partner: null,
            qrcodecheck: false,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            prolistx: [],
            prodetail: [],
            username: "",
            tabselect: (() => {
                // ตั้งค่าหน้าเริ่มต้นตาม URL (กันรีเฟรชแล้วเด้งกลับหน้าแรก)
                const map = { home: 0, deposit: 1, withdraw: 2, history: 3, profile: 8, rewards: 40, rank: 41, ufanews: 50, ufahighlight: 51, referral: 52, uploadslip: 35 };
                const seg = (window.location.pathname.split('/')[1] || '').toLowerCase();
                return map[seg] !== undefined ? map[seg] : 0;
            })(),
            showpass: false,
            amount: "",
            remark: "",

            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            limit: null,
            name: "",
            password: "",
            oldpassword: "",
            passwordcf: "",
            left: false,
            pathname: "",
            linelink: "",
            lineid: "",
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            pagecount: 1,
            username: null,
            picture: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            mainacc: [],
            paymentgateway: null,
            tabselectsec: 0,
            checkcashout: false,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            activeTab: 'deposit-history', // ค่าเริ่มต้น
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
            modalx: false,
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            hours: 0,
            minutes: 0,
            seconds: 0
        }
        this.timer = null; // เก็บตัวนับเวลา
        this.popupRef = createRef();
    }
    handleClickOutside = (event) => {
        const isOutside =
            !event.target.closest('[role="dialog"]'); // ตรวจสอบว่า target อยู่นอก role="presentation"
        if (isOutside) {
            this.closeModal();
        }
    };
    handleTabChange = (tabId) => {
        this.setState({ activeTab: tabId });
    };
    handleChange = (event) => {
        console.log(event.target.value);
        const { name, value } = event.target;
        this.setState({
            [name]: value,
        });
    };
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
        console.log("fname", fname);
        if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
            var title = 'error'
            var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (fname === "" || fname === null || fname === undefined) {

            var title = 'error'
            var text = 'คุณไม่ทำการใส่ ชื่อ-นามสกุล'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (password.length > 15) {
            var title = 'error'
            var text = 'Password สูงสุดไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = 'พาสเวิดต่ำไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = 'Password มากกว่า 6 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: this.state.userrecomend
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                    var title = 'success'
                    var text = 'ทำการสมัครเรียบร้อย กรุณารอสักครู่'
                    var object = { title, text }
                    await this.modalerror(object);

                    this.setState({
                        username: phoneNumber,
                        password: password,
                        finish: 1,
                    });


                }
                else if (res.data.status === 203) {
                    var title = 'error'
                    var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error'
                    var text = 'Username นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else {
                    var title = 'error'
                    var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง'
                    var object = { title, text }
                    this.modalerror(object);
                }
            });
        }


    };
    handleClickmodal = () => {
        // console.log(this.state.modalx);
        // if (!this.state.modalx) {
        //     //document.addEventListener("click", this.handleOutsideClick, false);
        // } else {
        //     document.removeEventListener("click", this.handleOutsideClick, false);
        // }

        // this.setState(prevState => ({
        //     modalx: !prevState.modalx
        // }));
    };
    closeModal = () => {
        this.setState({ modalpopup: false });
    };
    handleIosClick = () => {
        this.setState({ ios: true });
    };
    handleAndroidClick = () => {
        this.setState({ ios: false });
    };
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        clearInterval(this.timer); // ล้างตัวนับเมื่อคอมโพเนนต์ถูกถอดออก
    }
    getNextMondayTarget() {
        const now = new Date();
        let target = new Date();

        // คำนวณวันจันทร์ถัดไป
        const daysUntilMonday = (8 - now.getDay()) % 7; // คำนวณจำนวนวันที่เหลือถึงวันจันทร์
        target.setDate(now.getDate() + daysUntilMonday);
        target.setHours(1, 0, 0, 0); // ตั้งเป้าหมายเป็น 01:00 AM ของวันจันทร์

        // ถ้าขณะนี้เลยเวลาเป้าหมายไปแล้ว ให้เลื่อนเป้าหมายไปวันจันทร์ถัดไป
        if (now >= target) {
            target.setDate(target.getDate() + 7);
        }

        return target;
    }

    startCountdown() {
        let targetTime = this.getNextMondayTarget();

        this.timer = setInterval(() => {
            const now = new Date();
            const diff = targetTime - now;

            // ถ้าถึงเวลาเป้าหมายแล้ว ให้ตั้งเป้าหมายใหม่
            if (diff <= 0) {
                targetTime = this.getNextMondayTarget();
            }

            // คำนวณวัน ชั่วโมง นาที และวินาทีที่เหลือ
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            // อัปเดตสถานะ (state)
            this.setState({
                days: days >= 0 ? days : 0,
                hours: hours >= 0 ? hours : 0,
                minutes: minutes >= 0 ? minutes : 0,
                seconds: seconds >= 0 ? seconds : 0
            });
        }, 1000);
    }
    redeemrank = async (e, index) => {
        e.preventDefault();
        //console.log(index);

        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: 'คุณต้องการเคลม Rank หรือ ไม่?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/userredeemrank", {
                        User_id: Username,
                        rankno: index.no,
                        System: Systems,
                        amount: index.claimamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            const datas = res.data.message;
                            this.calllisthistory(Username);
                            this.checklogin();
                            Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
                        }
                        else {
                            Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
                        }
                    });

                }
            })
        }

    }
    handleFileSelectedt = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const previewUrl = URL.createObjectURL(files[0]);
            this.setState({
                files: files,
                previewUrl: previewUrl,
                isConfirmed: false, // รีเซ็ตให้ต้องกดยืนยันใหม่
            });
        }
    };


    confirmqrcode = async () => {
        await Swal.fire({
            title: 'success!',
            text: 'ยืนยันการเติมเงิน',
            icon: 'success',
            confirmButtonText: 'ตกลง'
        })
        this.setState({
            tabselect: 0,
            qrcode: null,
            tabselectdeposit: 0,
        });
    };
    cancleqrcode = () => {
        Swal.fire({
            title: "ยกเลิก QR code",
            html: 'คุณต้องการยกเลิกการใช้ Qr code',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#81d539",
            cancelButtonColor: "#ea133d",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.setState({
                    qrstep: 0,
                    qrcodecheck: false,
                    counter: 0,
                });
            }
        });
    };
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = this.state.webnamexback;
            }
        });
    }
    login = (e) => {
        e.preventDefault();
        let errors = this.validateLoginForm();
    }
    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }
    validateLoginForm = async (e) => {
        const { username, password } = this.state;
        console.log(username, password);
        await instance.post("/api/v1/userlogin", {
            userid: username,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
        })
            .then((res) => {
                console.log(res);
                if (res.status === 200) {
                    //////console.log(res.data.status);
                    if (res.data.status === 200) {
                        localStorage.setItem('auth_token', res.data.token)
                        localStorage.removeItem('cookie', '')
                        this.setState({
                            userid: res.data.message.member_id,
                            username: res.data.message.playerid,
                            firstname: res.data.message.firstname,
                            lastname: res.data.message.lastname,
                            point: res.data.message.Point,
                            balance: res.databalance,
                            loginstate: true,
                        });
                        window.location.href = '/';
                    }
                    else if (res.data.status === 401) {
                        Swal.fire({
                            title: 'error!',
                            text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'error!',
                            text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        })
                        //   Bonn.alert("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง")
                    }
                }
                else {
                    this.setState({
                        firstname: null,
                        lastname: null,
                        point: null,
                        loginstate: false,
                    });
                    var title = 'Error!'
                    var text = 'Username นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.CheckThisGoalError(object);
                }
            });
    }
    async checklogin() {
        var token = localStorage.getItem('auth_token');
        console.log(11111111, token);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
        }
        else {
            this.setState({
                loginstate: false,
            });
            await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
            console.log(this.state.webnamexback);
            window.location.href = this.state.webnamexback + '/login';
        }
    }
    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input
        });
        if (input == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }

    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.setState({
            checkcredit: true,
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            // console.log(2);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)

                    this.setState({
                        usercheck: res.data.message.usercheck,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                        checkcredit: false,
                    });
                }
                else if (res.data.status === 401) {
                    //   console.log(res.data);
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = this.state.webnamexback;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = this.state.webnamexback;
                }
            });
        }
        catch (ex) {
            ////////console.log(ex);
        }
    }
    // async opencliamcashout(evt, cityName) {
    //     var token = localStorage.getItem('auth_token');
    //     var decoded = jwt_decode(token);
    //     var Username = decoded.message.playerid;
    //     await instance.post("/api/v1/cliamcashout", {
    //         userid: Username,
    //         System: Systems,
    //     }, {
    //         headers: { Authorization: `Bearer ${token}` }
    //     }).then(async (res) => {
    //         if (res.data.status === 200) {
    //             var decoded = jwt_decode(token);
    //             var Username = decoded.message.playerid;
    //             this.rechecklogin(Username, token);
    //             await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
    //         }
    //         else if (res.data.status === 201) {
    //             await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
    //             return false;
    //         }
    //         else if (res.data.status === 202) {
    //             await this.notify("error", 'ไม่สามารถทำรายการได้');
    //             return false;
    //         }

    //     }).catch(async (err) => {
    //         // console.log(err);
    //         if (err.response.status === 401 || err.response.status === 403) {
    //             localStorage.clear();
    //             await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
    //             window.location.href = '/';
    //         }
    //     });
    // }
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    handleOutsideClick = e => {
        if (!this.node.contains(e.target)) this.handleClickmodal();
    };
    claerclass = async (e, url) => {
        var i, tabcontent, tablinks;
        tabcontent = document.querySelectorAll('[id*="game"]');
        Array.prototype.forEach.call(tabcontent, callback);
        function callback(element, iterator) {
            if (!isMobile) {
                element.className = "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-luxecs";
            }
            else if (isMobile) {
                element.className = "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-5oh6yz";
            }
        }
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    handleSelectItem = (item) => {
        if (item.id == 99) {
            this.setState({
                trueaccount: false,
                selectedItem: item,
                isPopupOpen: false,
                bankselect: item.id,
            });
        }
        else {
            this.setState({
                trueaccount: true,
                selectedItem: item,
                isPopupOpen: false,
                bankselect: item.id,
                fname: ""
            });
        }
        //  this.setState({}); // Store selected item and close menu
    };
    handleSubmit = async (event) => {
        event.preventDefault();
        const { oldPassword, newPassword, confirmPassword } = this.state;
        // console.log(type, newPassword, oldPassword, confirmPassword);
        var token = localStorage.getItem('auth_token');
        if (newPassword === confirmPassword) {
            var Username = null;
            var decoded = null;
            if (newPassword != oldPassword) {
                if (token != null) {
                    decoded = jwt_decode(token);
                    Username = decoded.message.playerid;
                    await instance.post("/api/v1/resetpassword", {
                        username: Username,
                        oldpass: oldPassword,
                        System: Systems,
                        newpass: newPassword,
                        type: 1
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.setState({
                                tabprofile: 1,
                            });
                            await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                        }
                        else if (res.data.status === 201) {
                            await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                        }
                        else if (res.data.status === 202) {
                            await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                        }
                    });
                }
                else {
                    await this.notify("error", 'ทำรายการไม่สำเร็จ');
                }
            }
            else {
                await this.notify("error", 'คุณใส่รหัสผ่านเดิม');
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }

    }
    closewheel(e) {
        e.preventDefault(); // ป้องกันพฤติกรรมเริ่มต้น
        this.setState({ luckywheeldisplay: false }); // ซ่อน Lucky Wheel
    }
    handleConfirmUpload = () => {
        if (this.state.files.length === 0) {
            this.notify("error", "กรุณาเลือกไฟล์ก่อนยืนยัน!");
            return;
        }
        this.setState({ isConfirmed: true }, () => {
            this.uploadSlip();
        });
    };

    uploadSlip = async () => {
        const { files, depositAmount, dateselect, inputTimeHour, inputTimeMin, mainacc } = this.state;
        const token = localStorage.getItem("auth_token");

        if (!token) {
            return this.notify("error", "ยังไม่ได้เข้าสู่ระบบ");
        }

        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;
            const formData = new FormData();
            formData.append("System", "javisauto");
            formData.append("image", files[0]);
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer langter",
            };

            const slip = await axios
                .post("https://apixgen.javisx.com:8801/api/v1/uploadslip", formData, { headers })
                .then((res) => res.data.link)
                .catch((error) => {
                    console.error("เกิดข้อผิดพลาด:", error);
                    return null;
                });

            if (!slip) {
                return this.notify("error", "อัปโหลดสลิปไม่สำเร็จ");
            }

            const object = {
                playerid: Username,
                amount: Number(this.state.depositamount) || 1,
                date: dateselect,
                minute: inputTimeMin,
                hour: inputTimeHour,
                bank: mainacc,
                slipimg: slip,
                System: Systems,
                type: 0,
            };

            await instance.post("/api/v1/updateslip", object).then(async (res) => {
                console.log(269, res.data);
                if (res.data.status == 200) {
                    await this.notify("success", 'ดำเนินการเรียบร้อย');
                }
                else {
                    await this.notify("error", res.data.message);
                    this.setState({ isUploading: false, isConfirmed: false });
                }
            });

        } catch (error) {
            this.notify("error", error.message);
        }
    };
    checkurl = async (e, url) => {
        NProgress.start();
        const pathname = url.split("/")
        console.log(210, url.split("/"));
        if (pathname.length > 1) {
            if (!this.state.loginstate && pathname[1] == "listgameall") {
                this.setState({
                    tabselect: 23,
                });
                return;
            }
            else {
                window.history.pushState(null, null, url);
                this.setState({
                    modalx: false,
                    modal: false,
                });
                if (pathname[1] == "") {
                    console.log(250, pathname[1]);
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "home") {
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {
                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "uploadslip") {
                    this.setState({
                        tabselect: 35,
                    });
                }


                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "luckywheel") {
                    this.setState({
                        tabselect: 33,
                    });
                }
                else if (pathname[1] == "slot") {
                    console.log(101, pathname);
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }

                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    this.setState({
                        tabselect: 1,
                        tabselectdeposit: 1,
                    });
                }
                else if (pathname[1] == "history") {
                    this.setState({
                        tabselect: 3,
                    });
                    try { const t = localStorage.getItem('auth_token'); if (t) { this.calllisthistory(jwt_decode(t).message.playerid); } } catch (e) { }
                }
                else if (pathname[1] == "profile") {
                    this.setState({
                        tabselect: 8,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "afficiate") {
                    this.setState({
                        tabselect: 4,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "rewards") {
                    this.setState({ tabselect: 40 });
                }
                else if (pathname[1] == "rank") {
                    this.setState({ tabselect: 41 });
                }
                else if (pathname[1] == "ufanews") {
                    this.setState({ tabselect: 50 });
                }
                else if (pathname[1] == "ufahighlight") {
                    this.setState({ tabselect: 51 });
                }
                else if (pathname[1] == "referral") {
                    this.setState({ tabselect: 52 });
                }
                else if (pathname[1] == "checkin") {
                    this.setState({ tabselect: 36 });
                }
                else if (pathname[1] == "cardgame") {
                    this.setState({ tabselect: 37 });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3], true);
                    console.log(614, check)
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
        }
        else {
            this.setState({
                tabselect: 0,
            });
        }
        NProgress.done();
    }
    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            console.log(864, res.data);
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                this.setState({
                    historylist: []
                });
                // this.CheckThisGoalError();
            }
        });

    }
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;

            });
        }
        return recheck
    }
    async modalerror(object) {
        await this.notify(object.title, object.text);
    }
    nextstep = async (e, num) => {
        e.preventDefault();
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        console.log(num);
        if (num === 1) {
            const check = await this.forgetotpandregister(6);
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
                }
                else {
                    await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรดรอสักครู่');
                }
            }
        }
        else if (num === 2) {

            if (password === "" || password === null) {
                await this.notify("warning", 'คุณไม่ได้ไส่พาสเวิด');
            }
            else if (password.length < 6) {
                await this.notify("warning", 'โปรดใส่พาสเวิดมากกว่า 6 ตัว');
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }

        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน 6 ตัว');
                //////console.log(2, stateregis, checkboxacc);
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", 'คุณใส่ตัวเลขไม่ครบ');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

            else {
                this.setState({
                    stateopterror: "รหัสผิดพลาด"
                });
                await this.notify("warning", 'รหัสผิดพลาด');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }



        }
        else if (num === 11) {

            console.log(1, stateregis, num);

            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            //////console.log(1, stateregis, num);
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            console.log("accnumbertxt", accnumbertxt);

            if (accnumbertxt === null || accnumbertxt === "" || typeof accnumbertxt == "undefined") {
                var title = 'error'
                var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
                var object = { title, text }
                this.modalerror(object);

            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);
                        if (check.verifications.status == 0) {
                            this.setState({
                                trueaccount: false,
                            });
                        }
                        else if (check.verifications.status == 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = 'เลขบัญชีไม่ถูกต้อง'
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false,
                });
                //console.log(302, check.verifications);
            }



        }
    };
    confirmdeposit = async (e, num) => {
        e.preventDefault();
        const token = localStorage.getItem('auth_token');
        if (!token) return;
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (num === 0) {
            if (this.state.depositamount >= this.state.limit.min && this.state.depositamount <= this.state.limit.max) {
                await instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    paymentstate: 1,
                    amount: this.state.depositamount,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    const d = res.data || {};
                    const gw = d.tblpaymentgatewayx || {};
                    const st = Number(d.status || gw.status);
                    const llx = this.state.linelink;
                    const msgX = d.message || gw.message || '';

                    // ── เคส QR เก่าค้างอยู่ ──
                    const isOld = d.isOld === true || gw.isOld === true
                        || ['old', 'reuse', 'exist', 'existing'].includes(String(d.state).toLowerCase())
                        || ['old', 'reuse', 'exist', 'existing'].includes(String(gw.state).toLowerCase())
                        || /ค้างอยู่|มีรายการฝาก|ยังไม่หมดอายุ|รายการเดิม|รายการฝากเดิม/.test(msgX);
                    const oldLink = gw.link || d.link || (d.rows && d.rows.qrcode) || gw.QRcode || d.qrcode || null;

                    if (isOld && oldLink) {
                        this.setState({ qrcode: null, depositstate: 0 });
                        const oldAmount = gw.amount || gw.trueamount || gw.Amount || d.amount || d.trueamount || this.state.depositamount || 0;
                        const amtStr = Number(oldAmount || 0).toLocaleString('en', { minimumFractionDigits: 2 });
                        Swal.fire({
                            title: '⚠ พบ QR Code เก่าค้างอยู่',
                            html: `<div style="font-size:14px;color:#333;line-height:1.7;">${msgX || 'พบรายการฝากเดิมที่ยังไม่หมดอายุ'}</div>`
                                + `<div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:10px;padding:12px 16px;margin:14px auto 0;max-width:300px;">`
                                + `<div style="font-size:12.5px;color:#9a3412;">QR Code / รายการเดิมที่ยังไม่หมดอายุ</div>`
                                + `<div style="font-size:26px;font-weight:800;color:#ea580c;margin-top:4px;">฿ ${amtStr}</div>`
                                + `</div>`
                                + `<div style="font-size:13.5px;color:#555;margin-top:14px;">ต้องการเปิดลิงก์ชำระเงินเดิมหรือไม่?</div>`,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: '🔗 เปิดลิงก์ชำระเงิน',
                            confirmButtonColor: '#0a5ebd',
                            cancelButtonText: '🚫 แจ้งยกเลิก',
                            cancelButtonColor: '#e74c3c'
                        }).then((r) => {
                            if (r.isConfirmed) {
                                this.setState({
                                    mainacc: d.mainacc || this.state.mainacc,
                                    listacc: d.tblmain,
                                    qrcode: gw.QRcode || oldLink,
                                    paymentList: { ...gw, link: oldLink, amount: oldAmount },
                                    paymentLink: oldLink,
                                    counter: 300,
                                    qrcodecheck: true,
                                    depositstate: 1
                                });
                                window.open(oldLink, '_blank', 'noopener,noreferrer');
                                this.notify('info', 'เปิดลิงก์ชำระเงินรายการเดิม กรุณาดำเนินการชำระเงิน');
                            } else if (r.dismiss === Swal.DismissReason.cancel && llx) {
                                window.open(llx, '_blank', 'noopener,noreferrer');
                            }
                        });
                        return;
                    }

                    // ── เคส error ──
                    if (d.success === false || gw.success === false || (st && st >= 202)) {
                        const msg = d.message || gw.message || 'ไม่สามารถสร้างรายการฝากได้ กรุณาลองใหม่อีกครั้ง';
                        this.setState({ qrcode: null, depositstate: 0 });
                        const lineBtn = llx
                            ? `<a href="${llx}" target="_blank" rel="noreferrer" style="display:inline-flex;align-items:center;gap:6px;margin-top:14px;background:#06C755;color:#fff;text-decoration:none;padding:9px 18px;border-radius:8px;font-weight:700;font-size:14px;">💬 แจ้งพนักงาน (LINE)</a>`
                            : '';
                        Swal.fire({
                            title: 'ไม่สามารถสร้างรายการได้',
                            html: `<div style="font-size:14.5px;color:#333;line-height:1.7;">${msg}</div>`
                                + `<div style="font-size:13px;color:#d35400;margin-top:10px;line-height:1.6;">โปรดใช้ QR เก่าในการชำระเงิน หรือแจ้งพนักงาน</div>`
                                + lineBtn,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                            confirmButtonColor: '#f5a623',
                            cancelButtonText: 'ยกเลิกรายการ',
                            cancelButtonColor: '#e74c3c'
                        }).then((r) => {
                            if (r.dismiss === Swal.DismissReason.cancel) {
                                Swal.fire({
                                    title: 'แจ้งยกเลิกรายการ',
                                    html: `<div style="font-size:14px;color:#333;line-height:1.7;">กรุณาติดต่อพนักงานผ่านไลน์ เพื่อยกเลิกรายการฝากที่ค้างอยู่</div>` + lineBtn,
                                    icon: 'info',
                                    confirmButtonText: 'ตกลง',
                                    confirmButtonColor: '#06C755'
                                });
                            }
                        });
                        return;
                    }

                    // ── เคส payment link (gateway) ──
                    const link = gw.link || d.link || null;
                    if (link && /^https?:\/\//.test(link)) {
                        const ua = navigator.userAgent;
                        const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes("Mac") && "ontouchend" in document);
                        if (isIOS) {
                            window.location.href = link;
                        } else if (!isMobile) {
                            window.open(link, "_blank", "noopener,noreferrer,width=1000,height=1000");
                        } else {
                            window.open(link, "_blank");
                        }
                    }

                    // ── ตั้งสถานะแสดงหน้า QR / รอดำเนินการ ──
                    this.setState({
                        mainacc: d.mainacc || this.state.mainacc,
                        listacc: d.tblmain,
                        qrcode: gw.QRcode || d.picture || null,
                        paymentLink: link || null,
                        paymentlist: gw,
                        counter: 300,
                        qrcodecheck: true,
                        depositstate: 1
                    });
                    this.notify("success", "กรุณาดำเนินการภายใน 5 นาที");
                });
            } else {
                await this.notify("warning", `เติมขั้นต่ำ ${this.state.limit.min} บาท สูงสุด ${this.state.limit.max} บาท`);
            }
        }
        else if (num === 1) {
            this.setState({ depositstate: 1 });
        }
        else if (num === 5) {
            document.getElementById("truemonney").click();
        }
        else {
            this.setState({ depositstate: 0 });
        }
    }
    togglePopup = () => {
        this.setState((prevState) => ({
            isPopupOpen: !prevState.isPopupOpen,
        }));
    };

    onChange = async (event) => {
        console.log(1163, event);
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            if (nam === "withdrawamount") {
                if (this.state.maxwithdrawstatus === 1) {
                    this.setState({ [nam]: this.state.balance });
                    await this.notify("warning", 'บังคับถอนยอดทั้งหมด');
                }
                else if (Number(val) <= Number(this.state.balance)) {
                    this.setState({ [nam]: val });
                }
                else {
                    await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');

                }
            } else {
                this.setState({ [nam]: val });
            }
            if (nam === "txtsech" || nam === "txtsech2") {
                const tabselect = this.state.tabselect
                let list = []
                let step = 1
                if (this.state.filterlist.length == 0) {
                    if (tabselect == 16 || tabselect == 20) {
                        list = this.state.listitallgame
                        step = 1
                    }
                    else if (tabselect == 13) {
                        list = this.state.slotlist
                        step = 2
                    }
                    else if (tabselect == 10) {
                        list = this.state.categorylist
                        step = 3
                    }
                    else if (tabselect == 14) {
                        list = this.state.sportlist
                        step = 4
                    }
                    else if (tabselect == 12) {
                        list = this.state.fishinglist
                        step = 5
                    }
                    else if (tabselect == 11) {
                        list = this.state.gamehitlist
                        step = 6
                    }
                    else if (tabselect == 18) {
                        list = this.state.providorlist
                        step = 7
                    }
                    this.setState({ filterlist: list });
                }
                else {
                    list = this.state.filterlist
                }
                let retailArrays = [];
                list.forEach(
                    array => {
                        console.log(1231, tabselect, step, array)
                        if (tabselect == 18 || tabselect == 10 || tabselect == 14) {
                            if (array.providername.toLowerCase().includes(val.toLowerCase())) {
                                retailArrays.push(array);
                            };
                        }
                        else {
                            if (array.description.toLowerCase().includes(val.toLowerCase())) {
                                retailArrays.push(array);
                            };
                        }
                    }
                )
                if (step == 1) this.setState({ listitallgame: retailArrays });
                else if (step == 2) this.setState({ slotlist: retailArrays });
                else if (step == 3) this.setState({ categorylist: retailArrays });
                else if (step == 4) this.setState({ sportlist: retailArrays });
                else if (step == 5) this.setState({ fishinglist: retailArrays });
                else if (step == 6) this.setState({ gamehitlist: retailArrays });
                else if (step == 7) this.setState({ providorlist: retailArrays });
            }

        }
    };
    submitwithdraw = async (e) => {
        console.log(this.state.withdrawamount, this.state.balance);
        if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
            if (parseFloat(this.state.withdrawamount) >= 10) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/userwithdraw", {
                        User_id: Username,
                        System: Systems,
                        amount: this.state.withdrawamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        console.log(res.data);
                        if (res.data.status === 200) {
                            await this.notify("success", 'รายการถอนเรียบร้อย');
                            this.checkurl(e, "/manager/statement")

                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", 'ท่านติด Turnover อีก ' + res.data.amountturnover + " บาท");

                        }
                        else if (res.data.status === 207) {
                            await this.notify("error", 'ขั้นต่ำในการถอน ' + res.data.maxwithdraw + " บาท");

                        }
                        else {
                            await this.notify("error", "ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน");
                        }
                    });
                }
                else {
                    await this.notify("error", 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน');
                }
            }
            else {
                await this.notify("warning", 'ขั้นต่ำในการถอน 50 บาท');
            }
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }

    }
    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf } = this.state;
        console.log(type, password, oldpassword, passwordcf);
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }
    }
    async opencliaminvite(evt, cityName) {
        // var str = "ต้องการถอนโบนัสจำนวน 0 เครดิต ใช่หรือไม่?\n" +
        //     "คุณจะได้รับเครดิตคืนจาก (สล็อต: 0 คาสิโนสด: 0 กีฬา: 0)\n";
        // Swal.fire({
        //     title: "ยืนยันการถอนโบนัส",
        //     html: '<pre>' + str + '</pre>',
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#81d539",
        //     cancelButtonColor: "#ea133d",
        //     confirmButtonText: "ยืนยัน",
        //     cancelButtonText: "ยกเลิก"
        // }).then(async (result) => {
        console.log(cityName);
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/cliaminvite", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    this.rechecklogin(Username, token);
                    await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ไม่สามารถทำรายการได้');
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = this.state.webnamexback;
                }
            });
        } else {
            await this.notify("error", 'คุณยังไม่ได้ล๊อคอิน');
            return false;
        }
        // });
    }
    handleClick = async (e, price) => {
        console.log(price);
        if (price <= this.state.balance) {
            this.setState({
                withdrawamount: price
            });
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }
    }
    handleClickreposit = async (e, price) => {
        this.setState({
            depositamount: price
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    await this.notify("success", 'รับโปรโมชั่นเรียบร้อย โปรดทำการเติมเงิน');
                    this.setState({
                        modalpromotion: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้');
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }
                else if (res.data.status === 204) {
                    await this.notify("error", 'ท่านใช้สิทธวันนี้ครบแล้ว');
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ท่านมีการรับโปรโมชั่น ค้างไว้');
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = this.state.webnamexback;
                }
            });
        }
    }
    redeem = async (e, gameIdx, partner) => {
        var userAgent = navigator.userAgent
        await this.checklogin();
        console.log(this.state.loginstate, 55555555)
        if (!this.state.loginstate) {
            await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return;
            //  return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {
            instance.post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: this.state.username,
                isMobile: isMobile,
                System: Systems,
                demo: false
            })
                .then((res) => {
                    if (res.data.status === 200) {
                        //////console.log(res.data.message);
                        var test = res.data.message.launcher
                        if (test !== undefined) {
                            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                window.location.href = test.mobile;
                            }
                            else {
                                if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                else window.open(test.mobile);
                            }
                        }
                        else if (test === undefined) {
                            this.notify("error", 'ขณะนี้เกมมีปัญหากรุณารอสักครู่');
                        }
                    }
                    else {
                        //  this.CheckThisGoalError();
                    }
                });
        }
        else {

        }


    }
    // เข้าเล่นเกมหลัก — เปิดหน้าต่างทันที (sync) กันป๊อปอัปถูกบล็อกหลัง await
    playMainGame = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const win = window.open('about:blank', '_blank');
        (async () => {
            await this.checklogin();
            if (!this.state.loginstate) {
                if (win) win.close();
                await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
                return;
            }
            try {
                const res = await instance.post("/api/v1/tablauncher", {
                    gameId: "sport",
                    partner: "uefa",
                    playerUsername: this.state.username,
                    isMobile: isMobile,
                    System: Systems,
                    demo: false
                });
                const test = res.data && res.data.message ? res.data.message.launcher : undefined;
                if (res.data.status === 200 && test) {
                    const url = isMobile ? test.mobile : test.desktop;
                    if (win) win.location.href = url; else window.location.href = url;
                } else {
                    if (win) win.close();
                    await this.notify("error", 'ขณะนี้เกมมีปัญหากรุณารอสักครู่');
                }
            } catch (err) {
                if (win) win.close();
                await this.notify("error", 'ไม่สามารถเปิดเกมได้ กรุณาลองใหม่');
            }
        })();
    }
    redeemcheck = async (e, ListItem) => {
        console.log(ListItem)
        var userAgent = navigator.userAgent
        this.checklogin();
        if (!this.state.loginstate) {
            await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return;
            //  return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {

            if (ListItem.gameId != undefined) {
                instance.post("/api/v1/tablauncher", {
                    gameId: ListItem.gameId,
                    partner: ListItem.partner,
                    playerUsername: this.state.username,
                    isMobile: isMobile,
                    System: Systems,
                    demo: false
                })
                    .then((res) => {
                        if (res.data.status === 200) {
                            //////console.log(res.data.message);
                            var test = res.data.message.launcher
                            if (test !== undefined) {
                                if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                    window.location.href = test.mobile;
                                }
                                else {
                                    if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                    else window.open(test.mobile);
                                }
                            }
                            else if (test === undefined) {
                                this.notify("error", 'ขณะนี้เกมมีปัญหากรุณารอสักครู่');
                            }
                        }
                        else {
                            //  this.CheckThisGoalError();
                        }
                    });
            }
            else {
                this.checkurl(e, "/game/list/" + ListItem.partner)
            }
        }
        else {

        }


    }

    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await this.notify("success", 'ดำเนินการใช้คูปองเรียบร้อย');
                }
                else {
                    await this.notify("warning", 'ไม่มี Key นี้ในระบบ');
                }
            });
        }
        else {
            await this.notify("warning", 'คุณไม่ได้ล๊อคอิน');
        }

    }

    copy = async (e, accnumber) => {
        toast.success("คัดลอกเรียบร้อย", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        navigator.clipboard.writeText(accnumber)
    }
    copyCode = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                setTimeout(function () {
                }, 3000);
            })
            .catch((err) => {
                // console.log(err.message);
            });
        this.notify("success", 'คัดลอกสำเร็จ !!');
    };



    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };

    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };

    async componentDidMount() {
        NProgress.start();
        const endpoint = "https://betner.co:9000";
        const socket = io.connect(endpoint);
        var roomid = Systems;
        var obj = { roomid }
        socket.on('connect', function (data) {
            var obj = { roomid }
            var json = JSON.stringify(obj);
            socket.emit('new', json);
        });


        document.body.className = "antialiased mx-auto";
        document.documentElement.className = "scroll-smooth";
        // โหลด CSS ธีม ufa7 (หน้า home เป็น ufa7 ล้วน) จาก local
        const U7 = '/idea-bet.live/theme/ufa7/';
        [
            U7 + 'style.css',
            U7 + 'assets/1760337585578/entry.B2LNsUBP.css',
            U7 + 'assets/1760337585578/main.BilVXsMl.css',
            U7 + 'assets/1760337585578/topBottomNav.Bb7jGTFt.css',
            U7 + 'assets/1760337585578/top-bottom-nav.Dl1XZL_C.css',
            U7 + 'assets/1760337585578/TopSectionInfo.mGnElULe.css',
            U7 + 'assets/1760337585578/TopRightBalanceContainer.NDVw_SCW.css',
        ].forEach(href => {
            if (!document.querySelector(`link[href="${href}"]`)) {
                const l = document.createElement('link');
                l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-home-ufa7', '1');
                document.head.appendChild(l);
            }
        });

        this.promotionlist();
        this.checklogin();
        try {
            const pathname = window.location.pathname.split("/");
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 30 * 60 * 1000; // 30 นาที

            // ตรวจสอบแคชสำหรับ main setting
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);

            if (mainSettingCache) {
                console.log("Using cached data for main setting");
                const data = mainSettingCache;

                document.title = data.tblsetting[0].title;
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link);

                if (data.tblsetting[0].imglogo) { try { window.localStorage.setItem('homeLogo', data.tblsetting[0].imglogo); } catch (e) {} }
                this.setState({
                    webname: data.tblsetting[0].Description,
                    logoimg: data.tblsetting[0].imglogo,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: data.message[1].value,
                    webnamex: data.message[7].value,
                    describemain: data.tblsetting[0].title,
                    System: data.tblcatagoryx[0].System,
                    cashoutSet: data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting[0],
                    datas: data.message,
                    limit: { min: data.tblcatagoryx[0].limitdeposit, max: data.tblcatagoryx[0].maxdeposit },
                });
            } else {
                await instance.post("/api/v1/mainsetting", {
                    System: Systems,
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("luckywheeldisplay", res.data);
                        const datas = res.data.message;
                        const min = res.data.tblcatagoryx[0].limitdeposit;
                        const max = res.data.tblcatagoryx[0].maxdeposit;
                        const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                        const limit = { min, max };
                        const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;

                        document.title = res.data.tblsetting[0].title;
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/svg+xml';
                        link.rel = 'icon';
                        link.href = res.data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(link);

                        if (res.data.tblsetting[0].imglogo) { try { window.localStorage.setItem('homeLogo', res.data.tblsetting[0].imglogo); } catch (e) {} }
                        this.setState({
                            webname: res.data.tblsetting[0].Description,
                            logoimg: res.data.tblsetting[0].imglogo,
                            whellsetting: res.data.tblwheelsetting,
                            maxwithdrawstatus: maxwithdrawstatus,
                            luckywheeldisplay: luckywheeldisplay,
                            linelink: datas[1].value,
                            webnamex: datas[7].value,
                            describemain: res.data.tblsetting[0].title,
                            System: res.data.tblcatagoryx[0].System,
                            cashoutSet: res.data.tblcashoutsetting[0],
                            inviteSet: res.data.tblinvitedsetting[0],
                            datas: datas,
                            limit: limit,
                        });

                        this.setCache(mainSettingKey, res.data);
                    }
                });
            }

            //   console.log(455, pathname[1] + "/" + pathname[2])
            const getTrueKey = `getTrueCache_${Username}_${Systems}`;
            const getTrueTTL = 30 * 60 * 1000; // 30 นาที
            const getTrueCache = this.getCache(getTrueKey, getTrueTTL);

            if (getTrueCache) {
                console.log("Using cached data for getTrue");
                this.setState({
                    trueaccount: getTrueCache,
                });
            } else {
                await instance.post("/api/v1/gettrue", {
                    userid: Username,
                    System: Systems,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log(res);
                        const trueAccount = res.data.message.tbltruewallet[0];

                        this.setState({
                            trueaccount: trueAccount,
                        });

                        this.setCache(getTrueKey, trueAccount);
                    }
                }).catch((err) => {
                    console.error("Error fetching getTrue data:", err);
                });
            }

            if (pathname.length > 1) {
                console.log(pathname);
                if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {

                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }
                else if (pathname[1] == "slot") {
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] == "luckywheel") {
                    this.setState({
                        tabselect: 33,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    // console.log(1232323)
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 1,
                            tabselectdeposit: 1,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "history") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 3,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "profile") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 8,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    console.log(63855555);
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "rewards") {
                    this.setState({ tabselect: 40 });
                }
                else if (pathname[1] == "rank") {
                    this.setState({ tabselect: 41 });
                }
                else if (pathname[1] == "ufanews") {
                    this.setState({ tabselect: 50 });
                }
                else if (pathname[1] == "ufahighlight") {
                    this.setState({ tabselect: 51 });
                }
                else if (pathname[1] == "referral") {
                    this.setState({ tabselect: 52 });
                }
                else if (pathname[1] == "checkin") {
                    this.setState({ tabselect: 36 });
                }
                else if (pathname[1] == "cardgame") {
                    this.setState({ tabselect: 37 });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3]);
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
            try {
                console.log(1625656556);
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await this.rechecklogin(Username, token);
                    this.setState({
                        userid: decoded.message.playerid,
                        username: decoded.message.playerid,
                        firstname: decoded.message.firstname,
                        lastname: decoded.message.lastname,
                        loginstate: true,
                    });
                }
                else {
                    this.setState({
                        loginstate: false,
                    });
                }


            }
            catch (error) {
                console.log(185222, error);
            }
            this.checklogin();
        }
        catch (error) {
            console.log(185222, error);
        }
        if (token != null) {
            var decoded = jwt_decode(token);
            let Username = decoded.message.playerid;
            instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: 50
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                console.log(res.data.picture)
                console.log(16888, res.data.mainacc)
                this.setState({
                    mainacc: res.data.mainacc,
                    listacc: res.data.tblmain,
                    paymentgateway: res.data.tblpaymentgatewayx,
                    paymentlist: res.data.tblpaymentgatewayx,
                }, () => {
                    // คืนหน้าเดิมตาม URL หลังรีเฟรช (ไม่เด้งกลับหน้าแรก)
                    const _p = window.location.pathname;
                    if (_p && _p !== '/' && _p !== '/home') {
                        this.checkurl(null, _p);
                    }
                });
            });
        }
        NProgress.done();
    }


    async checktab(e, index) {
        console.log(11111, index);
        if (index == 2) {
            //   await this.notify("error", 'ปิดระบบ QRcode ขัวคราว');
            this.setState({
                tabselectdeposit: index,
                tabselect: 1,
            });

        }
        else {
            this.setState({
                tabselectdeposit: index,
                tabselect: 1,
            });

            if (index == 3) {
                this.confirmdeposit(e, 0)
            }
        }
    }
    async checkuseradvice(username) {
        instance.post("/api/v1/checkuseradvice", {
            User_id: username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log("statsstatsstatsstats", res.data.message);
                this.setState({
                    stats: res.data.message.stats,
                    reports: res.data.message.reports,
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }
    async rechecklogin(Username, token) {

        try {
            console.log(4555555555555);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {

                if (res.data.status === 200) {
                    console.log(2142, res.data);
                    localStorage.setItem('auth_token', res.data.token)
                    this.checkuseradvice(Username); // ดึงรายชื่อเพื่อนที่แนะนำ (referral)
                    console.log(1067, res.data.userafftoday, res.data.useraffall);
                    var rankall = res.data.tblrankall;
                    const found = rankall.find(obj => {
                        return obj.checked === 1;
                    });
                    this.setState({
                        usercheck: res.data.usercheck,
                        tblrankall: res.data.tblrankall,
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        fullname: res.data.message.firstname,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        afficiatetoday: res.data.userafftoday,
                        afficiateall: res.data.useraffall,
                        buttoncliam: (found === undefined) ? true : false,
                        loginstate: true,
                    });

                    this.calllisthistory(Username);
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = this.state.webnamex + '/login';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = this.state.webnamex + '/login';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        modalpromotion: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        modalpromotion: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = this.state.webnamex + '/login';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    async opencliamcashout(evt, cityName) {
        var str = "ต้องการถอนโบนัสจำนวน 0 เครดิต ใช่หรือไม่?\n" +
            "คุณจะได้รับเครดิตคืนจาก (สล็อต: 0 คาสิโนสด: 0 กีฬา: 0)\n";
        Swal.fire({
            title: "ยืนยันการถอนโบนัส",
            html: '<pre>' + str + '</pre>',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#81d539",
            cancelButtonColor: "#ea133d",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);

                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/cliamcashout", {
                        userid: Username,
                        System: Systems,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            var decoded = jwt_decode(token);
                            var Username = decoded.message.playerid;
                            this.rechecklogin(Username, token);
                            this.notify("success", 'ทำรายการรับเงินเรียบร้อย');

                        }
                        else if (res.data.status === 201) {
                            await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                            return false;
                        }
                        else if (res.data.status === 202) {
                            await this.notify("error", 'ไม่สามารถทำรายการได้');
                            return false;
                        }

                    }).catch(async (err) => {
                        // console.log(err);
                        if (err.response.status === 401 || err.response.status === 403) {
                            localStorage.clear();
                            await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                            window.location.href = this.state.webnamex + '/login';
                        }
                    });
                }
                else {
                    await this.notify("error", 'คุณยังไม่ได้ล๊อคอิน');
                }
            }
        });

    }
    render() {
        const { activeTab } = this.state;
        const { oldPassword, newPassword, confirmPassword } = this.state;
        let { loginstate, usercheck, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile, limit } = this.state
        const { tabselectselect, accnumber, paymentlist, mainacc, trueaccount, listacc, tabselect } = this.state
        var limits = limit
        console.log("mainacc", paymentlist);
        const paymentArray = Array.isArray(paymentlist) ? paymentlist : (paymentlist ? [paymentlist] : []);
        const U7 = '/idea-bet.live/theme/ufa7/';   // ฐาน asset ธีม ufa7

        var accnumberx;
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        console.log(1326, tabselect);
        return (
            <>
                {/* ===== SIDEBAR (hamburger) — class ufa7 จริง (สไตล์จาก entry.css) ===== */}
                <div className={"side-nav-container " + (this.state.sidenavopen ? 'show' : '')}>
                    <div className={"side-nav-overlay " + (this.state.sidenavopen ? 'show' : '')} onClick={() => this.setState({ sidenavopen: false })}></div>
                    <div className={"side-nav-body " + (this.state.sidenavopen ? 'show' : '')}>
                        <div className="top-1 left-0 absolute" onClick={() => this.setState({ sidenavopen: false })}>
                            <img className="mx-auto mt-5 ml-5 w-[32px] h-[32px] cursor-pointer" src="/idea-bet.live/theme/ufa7/images/layout/icn-left-round.svg" alt="close" />
                        </div>
                        <div className="absolute top-5 right-5">
                            <img className="mx-auto w-[32px] h-[32px] cursor-pointer" width="32px" src="/idea-bet.live/theme/ufa7/images/language/icn-lang-th.svg" alt="lang" />
                        </div>
                        <div className="flex flex-col justify-center items-center" style={{ backgroundImage: 'url(/idea-bet.live/theme/ufa7/images/side-menu-profile-bg-top.png)' }}>
                            <div className="mt-6"><img className="w-[130px] h-[113px]" src="/idea-bet.live/theme/ufa7/images/membership/membership-logo-big-1.webp" alt="icn" /></div>
                            <div className="text-sm text-[#BD9D64] my-1">{this.state.rankname || ''}</div>
                            <div className="text-xl text-[#FFF] mb-4">{usercheck}</div>
                        </div>
                        <div className="nav-menu-body" style={{ background: 'linear-gradient(0deg, rgb(88, 66, 65) 19.44%, rgb(21, 21, 21) 100%)' }}>
                            <div className="nav-menu-link-container flex flex-col">
                                {[
                                    { l: 'หน้าหลัก', icon: 'icn-menu-home', url: '/home', tab: 0 },
                                    { l: 'ฝาก', icon: 'icn-menu-deposit', url: '/deposit', tab: 1 },
                                    { l: 'ถอน', icon: 'icn-menu-withdrawal', url: '/withdraw', tab: 2 },
                                    { l: 'ประวัติ', icon: 'icn-menu-history', url: '/history', tab: 3 },
                                    { l: 'โปรโมชั่น', icon: 'icn-menu-rewards', url: '/promotion', tab: 7 },
                                    { l: 'โปรไฟล์', icon: 'icn-menu-profiles', url: '/profile', tab: 8 },
                                ].map((m, i) => {
                                    const active = tabselect === m.tab;
                                    return (
                                        <a key={i} role="button" onClick={(e) => { this.setState({ sidenavopen: false }); this.checkurl(e, m.url); }} className="h-[52px] gap-1 flex flex-row font-normal items-center text-sm hover:bg-black">
                                            <img className="cursor-pointer my-1 ml-8 mr-4 w-[21px] h-[21px]" src={'/idea-bet.live/theme/ufa7/images/menu/' + m.icon + (active ? '-on' : '') + '.svg'} alt={m.l} />
                                            <span style={{ color: active ? '#fbdeb2' : '#BD9D64' }}>{m.l}</span>
                                        </a>
                                    );
                                })}
                            </div>
                            <div className="flex flex-col justify-center items-center my-[30px] mx-4">
                                <div className="w-full">
                                    <div role="button" onClick={(e) => { this.setState({ sidenavopen: false }); this.playMainGame(e); }} className="max-w-[300px] mx-auto text-center custom-button-round-bg flex justify-center items-center text-sm text-[#0A0425] font-semibold cursor-pointer">
                                        <div className="mr-2"><img className="max-w-[40px]" src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-play.svg" alt="icn" /></div>
                                        <div>เล่นเลย</div>
                                    </div>
                                </div>
                                <div className="my-2"></div>
                                <div className="w-full">
                                    <a role="button" onClick={() => { try { localStorage.clear(); } catch (e) { } window.location.href = '/'; }}>
                                        <div className="max-w-[300px] mx-auto custom-button-round-bg2 custom-button-round-bg flex justify-center items-center text-sm text-[#0A0425] font-semibold cursor-pointer">
                                            <div className="mr-2"><img className="max-w-[40px]" src="/idea-bet.live/theme/ufa7/images/layout/icn-logout.svg" alt="icn" /></div>
                                            <div style={{ color: '#fbdeb2' }}>ออกจากระบบ</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="my-2"></div>
                            </div>
                        </div>
                    </div>
                </div>{/* /side-nav */}

                {/* ===== WALLET bottom-modal (กดที่ยอดเงิน) ufa7 ===== */}
                {this.state.walletopen && (
                    <div className="fixed inset-0" style={{ zIndex: 9998 }}>
                        <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.6)' }} onClick={() => this.setState({ walletopen: false })}></div>
                        <div className="absolute bottom-0 left-0 right-0 mx-auto max-w-[438px] bottom-modal-selector-content show" style={{ background: '#1E1E1E', borderTopLeftRadius: 16, borderTopRightRadius: 16, zIndex: 9999 }}>
                            <div className="flex justify-between mx-6 mt-6 mb-4">
                                <div className="flex flex-row items-center">
                                    <div className="text-white text-sm">Wallet</div>
                                    <div className="ml-2 flex items-center mr-3 cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                            <path d="M12.326 5.82704H12.3254C12.2371 5.82711 12.1497 5.84458 12.0681 5.87844C11.9866 5.9123 11.9125 5.96188 11.8501 6.02437C11.7877 6.08686 11.7383 6.16103 11.7046 6.24263C11.6708 6.32424 11.6535 6.41168 11.6536 6.49998C11.6528 7.44259 11.3936 8.36694 10.9042 9.17255C10.4148 9.97816 9.71391 10.6342 8.87777 11.0694C8.04162 11.5046 7.10219 11.7022 6.16158 11.6409C5.22096 11.5795 4.31516 11.2615 3.54262 10.7214C1.21461 9.09133 0.646778 5.87111 2.27689 3.54306C3.90701 1.21502 7.12726 0.647138 9.45527 2.27731C9.80748 2.52328 10.1276 2.81229 10.4081 3.13764H8.516C8.33768 3.13764 8.16667 3.20847 8.04058 3.33456C7.91448 3.46065 7.84365 3.63167 7.84365 3.80999C7.84365 3.98831 7.91448 4.15932 8.04058 4.28541C8.16667 4.4115 8.33768 4.48234 8.516 4.48234H11.6536C11.832 4.48234 12.003 4.4115 12.1291 4.28541C12.2551 4.15932 12.326 3.98831 12.326 3.80999V0.672351C12.326 0.494032 12.2551 0.323017 12.1291 0.196927C12.003 0.0708368 11.832 0 11.6536 0C11.4753 0 11.3043 0.0708368 11.1782 0.196927C11.0521 0.323017 10.9813 0.494032 10.9813 0.672351V1.79201C10.7453 1.56815 10.4931 1.36214 10.2266 1.17569C9.52746 0.686173 8.73878 0.339149 7.90556 0.154432C7.07234 -0.0302852 6.21089 -0.0490781 5.3704 0.0991261C4.52992 0.24733 3.72685 0.559629 3.00706 1.01819C2.28727 1.47675 1.66485 2.0726 1.17533 2.77171C0.186705 4.18363 -0.200546 5.93044 0.0987661 7.62788C0.398078 9.32532 1.35944 10.8343 2.77135 11.823C3.85841 12.5886 5.15551 12.9997 6.48516 13C6.86813 12.9998 7.25036 12.9662 7.62749 12.8996C9.13227 12.6341 10.4954 11.847 11.4776 10.6765C12.4598 9.50595 12.9982 8.02682 12.9983 6.4988C12.9982 6.32059 12.9273 6.14973 12.8012 6.02377C12.6751 5.89781 12.5042 5.82705 12.326 5.82704Z" fill="#FBDEB2"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div className="cursor-pointer text-white text-lg" onClick={() => this.setState({ walletopen: false })}>✕</div>
                            </div>
                            <div className="flex-1 overflow-auto wallet-container">
                                <div className="currency-picker-container flex items-center relative cursor-pointer ml-4 mr-3 my-2 rounded-xl" style={{ background: 'linear-gradient(rgb(37,37,37), rgb(52,52,52))', border: '1px solid rgb(97,97,95)' }}>
                                    <div className="flex flex-row p-3 flex items-center w-full">
                                        <img src="/idea-bet.live/theme/ufa7/images/language/icn-lang-th.svg" alt="th" className="w-[22px] h-[22px] rounded-full object-cover" />
                                        <div className="text-[#F5F5F5] font-normal text-sm ml-3">THB - บาท</div>
                                        <div className="balance absolute right-6 text-[#FBDEB2]">{balance}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="mx-6 h-[1px] bg-gray-500 mt-2"></div>
                            <div className="mx-6 mt-4 pb-6 flex flex-row gap-3">
                                <a role="button" onClick={(e) => { this.setState({ walletopen: false }); this.checkurl(e, '/deposit'); }} className="w-full cursor-pointer">
                                    <div className="uf-btn-base uf-btn-primary h-[44px] rounded-xl flex items-center justify-center" style={{ color: 'black', background: 'linear-gradient(270deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}>
                                        <span className="uf-btn-label font-normal text-sm">ไปเติมเครดิตเลย!</span>
                                    </div>
                                </a>
                                <div role="button" onClick={() => this.setState({ walletopen: false })} className="w-full cursor-pointer">
                                    <div className="uf-btn-base uf-btn-secondary h-[44px] rounded-xl flex items-center justify-center" style={{ color: '#FBDEB2', background: 'transparent', border: '1px solid #8A7349' }}>
                                        <span className="uf-btn-label font-normal text-sm">ยกเลิก</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ===== BOTTOM NAV (ufa7) ===== */}
                <div
                    data-v-70c7d421=""
                    className="relative overflow-hidden mx-auto max-w-[438px]"
                >
                    <div data-v-70c7d421="">
                        <section data-v-70c7d421="" className="top-nav">
                            <div data-v-70c7d421="" className="grid grid-cols-3 pt-1">
                                <div data-v-70c7d421="" className="flex items-center pl-3">
                                    <div className="flex flex-col items-center">
                                        <div className="text-[#FDD387] text-xs pb-2">{usercheck}</div>
                                        <div className="flex flex-start items-center w-full">
                                            <div className="cursor-pointer x-hamburger" onClick={() => this.setState({ sidenavopen: true })}>
                                                <img
                                                    className="w-[17px] h-[12px]"
                                                    src="/idea-bet.live/theme/ufa7/images/layout/icn-burger.svg"
                                                    alt="icn"
                                                />
                                            </div>
                                            <div className="pl-2">
                                                <div className="cursor-pointer contactpopup" onClick={() => { if (this.state.linelink) window.open(this.state.linelink, '_blank', 'noopener,noreferrer'); }}>
                                                    <img
                                                        className="w-[28px] h-[24px]"
                                                        src="/idea-bet.live/theme/ufa7/images/nav-button-top-support.webp"
                                                        alt="SupportIcon"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    data-v-70c7d421=""
                                    className="flex justify-center items-center cursor-pointer"
                                >
                                    <a role="button" onClick={(e) => this.checkurl(e, "/home")}>
                                        <img
                                            className=""
                                            src={this.state.logoimg ? this.state.logoimg : '/idea-bet.live/theme/ufa7/images/UFABET-LOGO.webp'}
                                            alt="logo"
                                            style={{ objectFit: "fill" }}
                                            onError={(e) => { e.target.src = '/idea-bet.live/theme/ufa7/images/UFABET-LOGO.webp'; }}
                                        />
                                    </a>
                                </div>
                                <div data-v-98eb4b06="" className="flex justify-end relative">
                                    <div data-v-98eb4b06="" className="flex flex-col">
                                        <div
                                            data-v-98eb4b06=""
                                            className="top-balance text-xs text-right pt-2 md:max-w-[200px] min-h-[48px] pb-4"
                                        >
                                            <div
                                                data-v-98eb4b06=""
                                                className="flex flex-row h-full justify-center"
                                            >
                                                <div
                                                    data-v-98eb4b06=""
                                                    className="flex flex-col justify-center cursor-pointer creditBalanceContainer"
                                                >
                                                    <div data-v-98eb4b06="">
                                                        <span data-v-98eb4b06="" className="text-white text-xxxs">
                                                            {balance}
                                                        </span>
                                                        <span
                                                            data-v-98eb4b06=""
                                                            className="ml-1 mr-3 opacity-70 text-xxxs"
                                                        >
                                                            <span
                                                                data-v-98eb4b06=""
                                                                className="fi fi-th fis flag-icon"
                                                                title="th"
                                                            />
                                                        </span>
                                                    </div>
                                                    <div data-v-98eb4b06="" className="flex justify-end mt-1">
                                                        <span
                                                            data-v-98eb4b06=""
                                                            className="text-[#FFE161] text-xxxs"
                                                        >
                                                            0.5
                                                        </span>
                                                        <span data-v-98eb4b06="" className="ml-1 mr-3">
                                                            <img
                                                                data-v-98eb4b06=""
                                                                className="w-[14px] h-[14px] w-[14px] h-[14px]"
                                                                src="/idea-bet.live/theme/ufa7/images/layout/icn-ucoin.svg"
                                                                alt="ucoin"
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    data-v-98eb4b06=""
                                                    className="flex items-center mr-3 cursor-pointer"
                                                >
                                                    <svg
                                                        data-v-98eb4b06=""
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={13}
                                                        height={13}
                                                        viewBox="0 0 13 13"
                                                        fill="none"
                                                    >
                                                        <path
                                                            data-v-98eb4b06=""
                                                            d="M12.326 5.82704H12.3254C12.2371 5.82711 12.1497 5.84458 12.0681 5.87844C11.9866 5.9123 11.9125 5.96188 11.8501 6.02437C11.7877 6.08686 11.7383 6.16103 11.7046 6.24263C11.6708 6.32424 11.6535 6.41168 11.6536 6.49998C11.6528 7.44259 11.3936 8.36694 10.9042 9.17255C10.4148 9.97816 9.71391 10.6342 8.87777 11.0694C8.04162 11.5046 7.10219 11.7022 6.16158 11.6409C5.22096 11.5795 4.31516 11.2615 3.54262 10.7214C1.21461 9.09133 0.646778 5.87111 2.27689 3.54306C3.90701 1.21502 7.12726 0.647138 9.45527 2.27731C9.80748 2.52328 10.1276 2.81229 10.4081 3.13764H8.516C8.33768 3.13764 8.16667 3.20847 8.04058 3.33456C7.91448 3.46065 7.84365 3.63167 7.84365 3.80999C7.84365 3.98831 7.91448 4.15932 8.04058 4.28541C8.16667 4.4115 8.33768 4.48234 8.516 4.48234H11.6536C11.832 4.48234 12.003 4.4115 12.1291 4.28541C12.2551 4.15932 12.326 3.98831 12.326 3.80999V0.672351C12.326 0.494032 12.2551 0.323017 12.1291 0.196927C12.003 0.0708368 11.832 0 11.6536 0C11.4753 0 11.3043 0.0708368 11.1782 0.196927C11.0521 0.323017 10.9813 0.494032 10.9813 0.672351V1.79201C10.7453 1.56815 10.4931 1.36214 10.2266 1.17569C9.52746 0.686173 8.73878 0.339149 7.90556 0.154432C7.07234 -0.0302852 6.21089 -0.0490781 5.3704 0.0991261C4.52992 0.24733 3.72685 0.559629 3.00706 1.01819C2.28727 1.47675 1.66485 2.0726 1.17533 2.77171C0.186705 4.18363 -0.200546 5.93044 0.0987661 7.62788C0.398078 9.32532 1.35944 10.8343 2.77135 11.823C3.85841 12.5886 5.15551 12.9997 6.48516 13C6.86813 12.9998 7.25036 12.9662 7.62749 12.8996C9.13227 12.6341 10.4954 11.847 11.4776 10.6765C12.4598 9.50595 12.9982 8.02682 12.9983 6.4988C12.9982 6.32059 12.9273 6.14973 12.8012 6.02377C12.6751 5.89781 12.5042 5.82705 12.326 5.82704Z"
                                                            fill="url(#paint0_linear_2682_3241)"
                                                        />
                                                        <defs data-v-98eb4b06="">
                                                            <linearGradient
                                                                data-v-98eb4b06=""
                                                                id="paint0_linear_2682_3241"
                                                                x1="6.49917"
                                                                y1={0}
                                                                x2="6.49917"
                                                                y2={13}
                                                                gradientUnits="userSpaceOnUse"
                                                            >
                                                                <stop data-v-98eb4b06="" stopColor="#F1C67F" />
                                                                <stop
                                                                    data-v-98eb4b06=""
                                                                    offset={1}
                                                                    stopColor="#FBDEB2"
                                                                />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                </div>
                                                <div
                                                    data-v-98eb4b06=""
                                                    className="absolute pt-0 bottom-0 right-0 w-full"
                                                >
                                                    <div
                                                        data-v-d61bf512=""
                                                        data-v-98eb4b06=""
                                                        className="ucoin-progress-container cursor-pointer items-center justify-end gap-1"
                                                    >
                                                        <div data-v-d61bf512="" className="progress-bar-wrapper">
                                                            <div data-v-d61bf512="" className="progress-bar-track">
                                                                <div
                                                                    data-v-d61bf512=""
                                                                    className="progress-bar-fill"
                                                                    style={{ width: "0%" }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div data-v-d61bf512="" className="next-coin-section">
                                                            <span
                                                                data-v-d61bf512=""
                                                                className="next-value text-xxxxs pr-1 pb-[1px]"
                                                            >
                                                                ต่อไป: 0.6
                                                            </span>
                                                        </div>
                                                        {/**/}
                                                        {/**/}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/**/}
                            </div>
                        </section>
                    </div>
                    <div
                        data-v-70c7d421=""
                        id="top-bottom-nav"
                        className="h-[calc(100vh-72px)] overflow-auto"
                    >
                        {this.state.tabselect === 0 && (<>
                        <div
                            data-v-063232df=""
                            className="min-h-full bg-cover bg-center pb-[120px]"
                            style={{ backgroundImage: "url(/idea-bet.live/theme/ufa7/images/home-bg.webp)" }}
                        >
                            {/**/}
                            {/**/}
                            {/* POPUP */}
                            <div
                                data-v-6bae11b7=""
                                data-v-51a85cc6=""
                                data-v-063232df=""
                                className="custom-popup-mask hidden"
                            >
                                <div data-v-6bae11b7="" className="custom-popup-content top-[25%]">
                                    <div data-v-6bae11b7="" className="mx-auto max-w-[436px]">
                                        <div
                                            data-v-51a85cc6=""
                                            style={{
                                                position: "absolute",
                                                top: "min(150px, 15vh)",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                zIndex: 1000,
                                                width: "100%"
                                            }}
                                        >
                                            <div
                                                data-v-51a85cc6=""
                                                className="announcement-modal-container p-2 mx-auto max-w-[438px]"
                                            >
                                                <div
                                                    data-v-51a85cc6=""
                                                    className="flex justify-center items-center h-[35px]"
                                                >
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="w-[15px] flex items-center mx-2"
                                                    >
                                                        <img
                                                            data-v-51a85cc6=""
                                                            className="w-[15px] h-[17px] mt-1 cursor-pointer"
                                                            src="/idea-bet.live/theme/ufa7/images/layout/icn-left.svg"
                                                            alt="icn"
                                                        />
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex justify-center items-center"
                                                    >
                                                        <div data-v-51a85cc6="">
                                                            <div
                                                                data-v-51a85cc6=""
                                                                className="rounded-full mx-1 mt-1 bg-[#807E75] w-[7px] h-[7px]"
                                                                style={{ backgroundColor: "rgb(239, 208, 160)" }}
                                                            />
                                                        </div>
                                                        <div data-v-51a85cc6="">
                                                            <div
                                                                data-v-51a85cc6=""
                                                                className="rounded-full mx-1 mt-1 bg-[#807E75] w-[7px] h-[7px]"
                                                                style={{ backgroundColor: "rgb(128, 126, 117)" }}
                                                            />
                                                        </div>
                                                        <div data-v-51a85cc6="">
                                                            <div
                                                                data-v-51a85cc6=""
                                                                className="rounded-full mx-1 mt-1 bg-[#EFD0A0] w-[7px] h-[7px]"
                                                                style={{ backgroundColor: "rgb(128, 126, 117)" }}
                                                            />
                                                        </div>
                                                        <div data-v-51a85cc6="">
                                                            <div
                                                                data-v-51a85cc6=""
                                                                className="rounded-full mx-1 mt-1 bg-[#807E75] w-[7px] h-[7px]"
                                                                style={{ backgroundColor: "rgb(128, 126, 117)" }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="w-[15px] flex items-center mx-2"
                                                    >
                                                        <img
                                                            data-v-51a85cc6=""
                                                            className="w-[15px] h-[17px] mt-1 cursor-pointer"
                                                            src="/idea-bet.live/theme/ufa7/images/layout/icn-right.svg"
                                                            alt="icn"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="popupimage slide01home is-active">
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex justify-center text-center text-[#FFF] text-xs m-4"
                                                    >
                                                        ไก่คู่เดือดวันเสาร์ ที่ 18 ตุลาคม 2568
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex flex-1 justify-center items-center mt-2"
                                                    >
                                                        <div data-v-51a85cc6="" className="">
                                                            <div data-v-51a85cc6="" id="68ef531b805c7ba0fd5e7bc3">
                                                                <img
                                                                    data-v-51a85cc6=""
                                                                    className="rounded-lg announcement-modal-image"
                                                                    src="/idea-bet.live/theme/ufa7/images/alert/1510202507_66cb13f1-0815-46e1-8229-915763124956.jpeg"
                                                                />
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="popupimage slide02home">
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex justify-center text-center text-[#FFF] text-xs m-4"
                                                    >
                                                        โปรแกรมฟุตบอลวันนี้
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex flex-1 justify-center items-center mt-2"
                                                    >
                                                        <div data-v-51a85cc6="" className="">
                                                            <div data-v-51a85cc6="" id="68ee79edf98ff38e53113700">
                                                                <img
                                                                    data-v-51a85cc6=""
                                                                    className="rounded-lg announcement-modal-image"
                                                                    src="/idea-bet.live/theme/ufa7/images/alert/1410202516_1343693d-abf5-4374-aecc-c7b5a30a8868.jpeg"
                                                                />
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="popupimage slide03home">
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex justify-center text-center text-[#FFF] text-xs m-4"
                                                    >
                                                        หวยรัฐบาลไทย
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex flex-1 justify-center items-center mt-2"
                                                    >
                                                        <div data-v-51a85cc6="" className="">
                                                            <div data-v-51a85cc6="" id="68ea631e01dd46732bc75a67">
                                                                <img
                                                                    data-v-51a85cc6=""
                                                                    className="rounded-lg announcement-modal-image cursor-pointer"
                                                                    src="/idea-bet.live/theme/ufa7/images/alert/1110202514_c5cb685b-5e6a-4ea7-9df1-441878281f98.jpeg"
                                                                />
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="popupimage slide04home">
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex justify-center text-center text-[#FFF] text-xs m-4"
                                                    >
                                                        ขั้นตอนติดต่อแอดมิน
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="flex flex-1 justify-center items-center mt-2"
                                                    >
                                                        <div data-v-51a85cc6="" className="">
                                                            <div data-v-51a85cc6="" id="67cc5b73a6224dd1105d8e2f">
                                                                <img
                                                                    data-v-51a85cc6=""
                                                                    className="rounded-lg announcement-modal-image"
                                                                    src="/idea-bet.live/theme/ufa7/images/alert/0803202515_ba60a539-9800-46c2-92fb-5f4d6a8577f5.jpeg"
                                                                />
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    data-v-51a85cc6=""
                                                    className="flex flex-col justify-center items-center text-center"
                                                >
                                                    <div data-v-51a85cc6="" className="inline-flex items-center">
                                                        <label
                                                            data-v-51a85cc6=""
                                                            className="relative flex cursor-pointer items-center rounded-full p-3"
                                                            htmlFor="checkbox"
                                                            data-ripple-dark="true"
                                                            style={{ backgroundColor: "rgb(128, 126, 117)" }}
                                                        >
                                                            <input
                                                                data-v-51a85cc6=""
                                                                id="checkbox"
                                                                type="checkbox"
                                                                className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-[#FDD387] transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#FDD387] checked:bg-transparent checked:before:bg-transparent hover:before:opacity-10"
                                                            />
                                                            <div
                                                                data-v-51a85cc6=""
                                                                className="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-[#FDD387] opacity-0 transition-opacity peer-checked:opacity-100"
                                                            >
                                                                <svg
                                                                    data-v-51a85cc6=""
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    className="h-3.5 w-3.5"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                    stroke="currentColor"
                                                                    strokeWidth={1}
                                                                >
                                                                    <path
                                                                        data-v-51a85cc6=""
                                                                        fillRule="evenodd"
                                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </label>
                                                        <span
                                                            data-v-51a85cc6=""
                                                            className="my-2 text-[11px] text-[#FDD387]"
                                                        >
                                                            ไม่ต้องแสดงอีก สำหรับวันนี้
                                                        </span>
                                                    </div>
                                                    <div
                                                        data-v-51a85cc6=""
                                                        className="announcement-modal-btn flex justify-center items-center text-center text-xs my-2 cursor-pointer"
                                                    >
                                                        ปิด
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* POPUP */}
                            {/* POPUP LINE */}
                            <div
                                data-v-6bae11b7=""
                                data-v-8f46568d=""
                                className="custom-popup-mask contactpopupbox"
                                style={{ zIndex: 2202 }}
                            >
                                <div data-v-6bae11b7="" className="custom-popup-content top-[25%]">
                                    <div data-v-6bae11b7="" className="mx-auto max-w-[436px]">
                                        <div data-v-8f46568d="" className="contact-list-container">
                                            <div
                                                data-v-4efc9fac=""
                                                data-v-8f46568d=""
                                                className="flex justify-around items-center social-media-box cursor-pointer social-media-box-line"
                                            >
                                                <div data-v-4efc9fac="" className="ml-1 mr-1 p-1">
                                                    <img
                                                        data-v-4efc9fac=""
                                                        className="icon-img w-[22px] h-[22px]"
                                                        src="/idea-bet.live/theme/ufa7/images/layout/icn-line.svg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div
                                                    data-v-4efc9fac=""
                                                    className="text-[#FFF] text-xs font-bold mr-3"
                                                >
                                                    ติดต่อเจ้าหน้าที่
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* POPUP LINE */}
                            <div
                                data-v-4e25a4fb=""
                                data-v-063232df=""
                                className="w-full h-[362px] max-h-[362px] relative d-block"
                                style={{
                                    background: "url(/idea-bet.live/theme/ufa7/images/top-1.webp) 0px 0px / 100% no-repeat"
                                }}
                            >
                                <div data-v-4e25a4fb="">
                                    <div data-v-adcf7e51="" data-v-4e25a4fb="">
                                        <table data-v-adcf7e51="" className="w-full cursor-pointer">
                                            <tbody>
                                                <tr data-v-adcf7e51="">
                                                    <td data-v-adcf7e51="" className="w-[33px]">
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/home")}>
                                                            <img
                                                                data-v-adcf7e51=""
                                                                className="ml-3 mb-2 w-[13px] h-[12.46px]"
                                                                src="/idea-bet.live/theme/ufa7/images/layout/icn-announcement.svg"
                                                                alt="icn"
                                                            />
                                                        </a>
                                                    </td>
                                                    <td data-v-adcf7e51="">
                                                        <marquee
                                                            data-v-adcf7e51=""
                                                            behavior="scroll"
                                                            direction="left"
                                                            onmouseover="this.stop();"
                                                            onmouseout="this.start();"
                                                        >
                                                            <div
                                                                data-v-adcf7e51=""
                                                                className="announcement-text whitespace-nowrap font-normal text-xs"
                                                            >
                                                                <h2>
                                                                    <strong>
                                                                        📢 ช่วงเวลา 00.00 - 01.20 น. ของทุกวัน
                                                                        เป็นช่วงที่ธนาคารอัปเดตระบบประจำวัน
                                                                        อาจทำให้ช่วงเวลาดังกล่าวยอดเงินจะเข้าช้ากว่าปกติ
                                                                        ขออภัยในความไม่สะดวกค่ะ 🙏
                                                                    </strong>
                                                                </h2>
                                                            </div>
                                                        </marquee>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div data-v-4e25a4fb="" className="pt-4">
                                    <div
                                        data-v-4e25a4fb=""
                                        className="flex flex-col text-center justify-center"
                                    >
                                        <div
                                            data-v-4e25a4fb=""
                                            className="justify-self-center place-content-center text-sm text-[#FBDEB2]"
                                        >
                                            ยินดีต้อนรับ,
                                        </div>
                                        <div
                                            data-v-4e25a4fb=""
                                            className="text-[24px] text-center text-white"
                                        >
                                            {usercheck}
                                        </div>
                                        {/**/}
                                        <div
                                            data-v-4e25a4fb=""
                                            className="text-[24px] text-center text-[#ecca77] text-sm bg-black/20 rounded-full py-1 px-3 mb-2 text-[32px] max-w-[280px] mx-auto"
                                        >
                                            {username}
                                        </div>
                                    </div>
                                </div>
                                <div data-v-4e25a4fb="" className="flex justify-center pt-1 pb-6">
                                    <div data-v-8402a1c1="" data-v-4e25a4fb="" className="flex flex-row">
                                        <div
                                            data-v-8402a1c1=""
                                            className="flex justify-center items-center creditBalanceContainer balance-pill"
                                        >
                                            <div
                                                data-v-8402a1c1=""
                                                className="m-1 content-center h-[30px] min-w-[42px] text-[#D0AE71] text-xs credit-currency-container"
                                            >
                                                <span data-v-8402a1c1="" className="ml-2">
                                                    บาท
                                                </span>
                                            </div>
                                            <div
                                                data-v-8402a1c1=""
                                                className="flex flex-row justify-center items-center cursor-pointer"
                                                onClick={() => this.setState({ walletopen: true })}
                                            >
                                                <div
                                                    data-v-8402a1c1=""
                                                    className="text-l text-[#FBDEB2] mr-2 credit-balance-container"
                                                >
                                                    {balance}
                                                </div>
                                                <div data-v-8402a1c1="" className="mr-4">
                                                    <img
                                                        data-v-8402a1c1=""
                                                        src="data:image/svg+xml,%3csvg%20width='11'%20height='6'%20viewBox='0%200%2011%206'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.5%201L5.50056%205L1.5%201'%20stroke='%238C8C8C'%20stroke-width='2'%20stroke-miterlimit='10'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/deposit")}>
                                            <div
                                                data-v-8402a1c1=""
                                                className="ml-2 flex justify-center items-center currencySelectButton cursor-pointer"
                                            >
                                                <img
                                                    data-v-8402a1c1=""
                                                    src="data:image/svg+xml,%3csvg%20width='34'%20height='34'%20viewBox='0%200%2034%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='33'%20height='33'%20rx='16.5'%20fill='url(%23paint0_linear_5229_3448)'%20fill-opacity='0.45'%20stroke='%2361615F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.9997%2011.0623C16.7335%2011.0623%2016.4781%2011.1681%2016.2898%2011.3564C16.1015%2011.5446%2015.9958%2011.8003%2015.9958%2012.0666L16.0009%2016.3776L11.6895%2016.3725C11.4232%2016.3725%2011.1679%2016.4783%2010.9796%2016.6666C10.7913%2016.8549%2010.6855%2017.1102%2010.6855%2017.3765C10.6855%2017.6428%2010.7913%2017.8981%2010.9796%2018.0864C11.1679%2018.2747%2011.4235%2018.3805%2011.6898%2018.3805L16.0009%2018.3753L15.9958%2022.6867C15.9958%2022.8186%2016.0217%2022.9491%2016.0722%2023.0709C16.1227%2023.1927%2016.1966%2023.3034%2016.2898%2023.3966C16.3831%2023.4899%2016.4937%2023.5638%2016.6155%2023.6143C16.7373%2023.6647%2016.8679%2023.6907%2016.9997%2023.6907C17.1316%2023.6907%2017.2621%2023.6647%2017.3839%2023.6143C17.5057%2023.5638%2017.6164%2023.4899%2017.7097%2023.3966C17.8029%2023.3034%2017.8768%2023.1927%2017.9273%2023.0709C17.9777%2022.9491%2018.0037%2022.8183%2018.0037%2022.6864L17.9986%2018.3753L22.3095%2018.38C22.4414%2018.38%2022.5719%2018.354%2022.6937%2018.3036C22.8155%2018.2531%2022.9262%2018.1792%2023.0194%2018.086C23.1127%2017.9927%2023.1866%2017.8821%2023.2371%2017.7602C23.2875%2017.6384%2023.3135%2017.5079%2023.3135%2017.376C23.3135%2017.2442%2023.2875%2017.1136%2023.2371%2016.9918C23.1866%2016.87%2023.1127%2016.7594%2023.0194%2016.6661C22.9262%2016.5729%2022.8155%2016.499%2022.6937%2016.4485C22.5719%2016.398%2022.4411%2016.3721%2022.3092%2016.3721L17.9982%2016.3772L18.0037%2012.0663C18.0037%2011.8%2017.8979%2011.5446%2017.7097%2011.3564C17.5214%2011.1681%2017.266%2011.0623%2016.9997%2011.0623Z'%20fill='url(%23paint1_linear_5229_3448)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_5229_3448'%20x1='17'%20y1='0'%20x2='17'%20y2='34'%20gradientUnits='userSpaceOnUse'%3e%3cstop/%3e%3cstop%20offset='1'%20stop-color='%235E5544'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_5229_3448'%20x1='16.9995'%20y1='11.0623'%20x2='16.9933'%20y2='23.6907'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%238B6832'/%3e%3cstop%20offset='1'%20stop-color='%23FCDD9A'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e"
                                                />
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div data-v-4e25a4fb="" className="flex justify-center pt-1 pb-6 mx-12">
                                    {/**/}
                                </div>
                                <div data-v-4e25a4fb="" className="custom-rank-container">
                                    <div data-v-c62383a5="" data-v-4e25a4fb="">
                                        <div data-v-c62383a5="" className="flex-1 relative">
                                            <div data-v-c62383a5="" className="float-right">
                                                <a role="button" onClick={(e) => this.checkurl(e, "/rank")}>
                                                    <div
                                                        data-v-c62383a5=""
                                                        className="w-[72px] h-[38px] rounded-l-2xl shrink-0 items-center justify-center rankCustomButton cursor-pointer"
                                                        style={{
                                                            backgroundImage: "url(/idea-bet.live/theme/ufa7/images/rank/icn-rank-button-bg.svg)"
                                                        }}
                                                    >
                                                        <img
                                                            data-v-c62383a5=""
                                                            className="w-[36px] h-[36px] float-left ml-2"
                                                            src="/idea-bet.live/theme/ufa7/images/membership/membership-logo-1.webp"
                                                            alt="icn"
                                                        />
                                                        <img
                                                            data-v-c62383a5=""
                                                            className="w-[14px] h-[14px] mr-2 mt-3.5 float-right"
                                                            src="/idea-bet.live/theme/ufa7/images/rank/icn-rank-right-arrow.svg"
                                                            alt="icn"
                                                        />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Banner checkurl={this.checkurl} />
                            <div data-v-063232df="" className="max-w-[320px] mx-auto relative">
                                {/**/}
                            </div>
                            <div data-v-063232df="" className="home-menu-container">
                                <div data-v-063232df="" className="keen-slider">
                                    <div
                                        data-v-063232df=""
                                        className="keen-slider__slide pt-[20px] p-4"
                                        style={{
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            transform: "translate3d(0px, 0px, 0px)"
                                        }}
                                    >
                                        <div data-v-063232df="" className="flex flex-col">
                                            <div data-v-063232df="" className="flex flex-1">
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/deposit")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-deposit.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    ฝาก
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/withdraw")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-withdrawal.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    ถอน
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/history")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-history.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    ประวัติ
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/profile")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-settings.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    ตั้งค่า
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div data-v-063232df="" className="flex flex-1">
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/rank")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-membership.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    สมาชิก
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/promotion")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-rewards-on.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    โปรโมชั่น
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={() => Swal.fire({ title: 'ยังไม่เปิดให้บริการ', text: 'Pretty Live กำลังจะเปิดให้บริการเร็ว ๆ นี้', icon: 'info', confirmButtonText: 'ตกลง' })}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%]"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-full h-full">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-upretty.png"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    Pretty Live
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/ufanews")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%]"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-full h-full">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-ufanews.png"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    UFA News
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div data-v-063232df="" className="flex flex-1">
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/ufahighlight")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-highlights.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    Highlight
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div
                                                        data-v-244faeec=""
                                                        data-v-063232df=""
                                                        className="w-full cursor-pointer relative pb-[130%]"
                                                    >
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/referral")}>
                                                            <div
                                                                data-v-244faeec=""
                                                                className="absolute top-0 left-0 h-full w-full px-3"
                                                            >
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox"
                                                                >
                                                                    <div
                                                                        data-v-244faeec=""
                                                                        className="absolute top-0 left-0 h-full w-full flex justify-center items-center"
                                                                    >
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img
                                                                                data-v-244faeec=""
                                                                                className="w-full h-full"
                                                                                src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-referral.svg"
                                                                                alt="icn"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    data-v-244faeec=""
                                                                    className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2"
                                                                >
                                                                    แนะนำเพื่อน
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div data-v-244faeec="" data-v-063232df="" className="w-full cursor-pointer relative pb-[130%]">
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/rank")}>
                                                            <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full px-3">
                                                                <div data-v-244faeec="" className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox">
                                                                    <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full flex justify-center items-center">
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img data-v-244faeec="" className="w-full h-full" src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-rank.svg" alt="icn" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div data-v-244faeec="" className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2">ระบบแรงค์</div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div data-v-244faeec="" data-v-063232df="" className="w-full cursor-pointer relative pb-[130%]">
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/checkin")}>
                                                            <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full px-3">
                                                                <div data-v-244faeec="" className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox">
                                                                    <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full flex justify-center items-center">
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img data-v-244faeec="" className="w-full h-full" src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-checkin.svg" alt="icn" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div data-v-244faeec="" className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2">เกมส์เชคอิน</div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div data-v-063232df="" className="flex flex-1">
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div data-v-244faeec="" data-v-063232df="" className="w-full cursor-pointer relative pb-[130%]">
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/cardgame")}>
                                                            <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full px-3">
                                                                <div data-v-244faeec="" className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox">
                                                                    <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full flex justify-center items-center">
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img data-v-244faeec="" className="w-full h-full" src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-card.svg" alt="icn" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div data-v-244faeec="" className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2">เปิดไพ่</div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div data-v-063232df="" className="flex basis-1/4">
                                                    <div data-v-244faeec="" data-v-063232df="" className="w-full cursor-pointer relative pb-[130%]">
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/luckywheel")}>
                                                            <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full px-3">
                                                                <div data-v-244faeec="" className="flex flex-shrink-0 items-center justify-center relative w-full pb-[100%] buttonBox">
                                                                    <div data-v-244faeec="" className="absolute top-0 left-0 h-full w-full flex justify-center items-center">
                                                                        <div data-v-244faeec="" className="w-[50%] h-[50%]">
                                                                            <img data-v-244faeec="" className="w-full h-full" src="/idea-bet.live/theme/ufa7/images/button-icon/icn-btn-wheel.svg" alt="icn" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div data-v-244faeec="" className="text-[#FBDEB2] mt-2 text-center text-xs line-clamp-2">กงล้อ</div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/**/}
                                </div>
                                {/**/}
                            </div>
                            <div data-v-063232df="" className="p-4">
                                <div data-v-063232df="" className="pt-6" />
                                <div
                                    data-v-063232df=""
                                    className="announcement-container flex flex-col"
                                >
                                    <div data-v-063232df="" className="text-[#FFF] p-6">
                                        👉ใหม่ ระบบแนะนำเพื่อน👈🎉เพื่อนยิ่งเล่น เรายิ่งได้🎉
                                        <img src="https://s3.newworld.center/image/2d875163-2bbc-4c68-a7c3-cd7de96fe77b.webp" />
                                        👉หากติดปัญหาติดต่อไลน์ได้ที่ LINE ID : @kc777
                                        <img src="https://s3.newworld.center/image/1ad0bf89-b090-4c41-9b70-58cbd5ed665a.webp" />
                                        <a role="button" onClick={() => { if (this.state.linelink) window.open(this.state.linelink, '_blank', 'noopener,noreferrer'); }} className="cursor-pointer">
                                            <img
                                                src="/idea-bet.live/theme/ufa7/scdn.line-apps.com/n/line_add_friends/btn/th.png"
                                                alt="เพิ่มเพื่อน"
                                                height={36}
                                                border={0}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>)}
                        {this.state.tabselect === 1 && (
                            <div className="depositbox boxsfirststep slide-in min-h-full bg-cover bg-center pb-[120px]" style={{ backgroundImage: "url(/idea-bet.live/theme/ufa7/images/home-bg.webp)" }}>
                                {/* ===== STEP 1: เลือกวิธีฝาก ===== */}
                                {(this.state.depositstep !== 1 && !this.state.qrcodecheck) && (
                                <div className="relative custom-container pt-3">
                                    <div className="profile-tab flex justify-around items-center text-sm">
                                        <a role="button" onClick={(e) => { this.setState({ depositstep: 0 }); this.checkurl(e, "/deposit"); }}>
                                            <div className="cursor-pointer pb-2 tab-line text-[#FBDEB2]">ฝาก</div>
                                        </a>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/withdraw")}>
                                            <div className="cursor-pointer pb-2 text-white">ถอน</div>
                                        </a>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/history")}>
                                            <div className="cursor-pointer pb-2 text-white">ประวัติ</div>
                                        </a>
                                    </div>
                                    <div className="mx-6 mt-2 depositnowait slide-in">
                                        <div className="depositnowait">
                                            {/* แบบ 1: ฝาก Payment (โชว์เมื่อเปิด payment gateway) */}
                                            {this.state.paymentgateway != null && (
                                            <div
                                                className="mb-3 selectqrcode cursor-pointer"
                                                onClick={() => this.setState({ depositstep: 1, depositmethod: 'qr', depositstate: 0 })}
                                            >
                                                <div className="deposit-provider-option-container">
                                                    <div className="deposit-provider-option-content flex flex-row items-center p-3">
                                                        <div className="icon-container bottom-animation w-[54px] h-[54px] flex justify-center items-center">
                                                            <img src="/idea-bet.live/theme/ufa7/images/deposit/icn-qr-scan.svg" />
                                                        </div>
                                                        <div className="flex flex-row ml-4 w-full">
                                                            <div className="flex flex-col w-full">
                                                                <div className="flex items-center">
                                                                    <span className="text-[#FBDEB2] font-semibold">ฝาก Payment</span>
                                                                    <span className="ml-2 text-xs text-white bg-[#2d7d46] rounded px-2 py-[1px]">🚀 Fastest</span>
                                                                </div>
                                                                <span className="text-white text-xs mt-1">สแกนจ่ายด้วย Mobile Banking</span>
                                                                <div className="flex flex-row gap-2 mt-2">
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">ขั้นต่ำ: 100</span>
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">สูงสุด: 100,000</span>
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">~1 min</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                            {/* แบบ 2: ฝากปกติ (โอน/คัดลอกบัญชี) — มีเสมอ */}
                                            <div
                                                className="mb-3 selectbank cursor-pointer"
                                                onClick={() => this.setState({ depositstep: 1, depositmethod: 'bank', depositstate: 0 })}
                                            >
                                                <div className="deposit-provider-option-container">
                                                    <div className="deposit-provider-option-content flex flex-row items-center p-3">
                                                        <div className="icon-container bottom-animation w-[54px] h-[54px] flex justify-center items-center">
                                                            <img src="/idea-bet.live/theme/ufa7/images/deposit/icn-manual-deposit.svg" />
                                                        </div>
                                                        <div className="flex flex-row ml-4 w-full">
                                                            <div className="flex flex-col w-full">
                                                                <div className="flex items-center">
                                                                    <span className="text-[#FBDEB2] font-semibold">ฝากปกติ</span>
                                                                </div>
                                                                <span className="text-white text-xs mt-1">โอนเงินเข้าบัญชี (คัดลอกเลขบัญชี)</span>
                                                                <div className="flex flex-row gap-2 mt-2">
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">ขั้นต่ำ: 1</span>
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">~1-5 min</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* แบบ 5: ทรูมันนี่ วอลเล็ท — โชว์เมื่อเว็บมีบัญชี TrueWallet สำหรับรับฝาก */}
                                            {(trueaccount && trueaccount.telnumber) && (
                                            <div
                                                className="mb-3 selecttrue cursor-pointer"
                                                onClick={() => this.setState({ depositstep: 1, depositmethod: 'true', depositstate: 0 })}
                                            >
                                                <div className="deposit-provider-option-container">
                                                    <div className="deposit-provider-option-content flex flex-row items-center p-3">
                                                        <div className="icon-container bottom-animation w-[54px] h-[54px] flex justify-center items-center rounded-lg" style={{ background: '#ff6a00' }}>
                                                            <span className="text-white font-bold text-lg">true</span>
                                                        </div>
                                                        <div className="flex flex-row ml-4 w-full">
                                                            <div className="flex flex-col w-full">
                                                                <div className="flex items-center">
                                                                    <span className="text-[#FBDEB2] font-semibold">ทรูมันนี่ วอลเล็ท</span>
                                                                </div>
                                                                <span className="text-white text-xs mt-1">โอนผ่าน TrueMoney Wallet</span>
                                                                <div className="flex flex-row gap-2 mt-2">
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">ขั้นต่ำ: 1</span>
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">~1 min</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                            {/* แบบ 4: อัพโหลดสลิป (standalone) — โชว์ทุกคน */}
                                            <div
                                                className="mb-3 selectslip cursor-pointer"
                                                onClick={(e) => this.checkurl(e, "/uploadslip")}
                                            >
                                                <div className="deposit-provider-option-container">
                                                    <div className="deposit-provider-option-content flex flex-row items-center p-3">
                                                        <div className="icon-container bottom-animation w-[54px] h-[54px] flex justify-center items-center">
                                                            <img src="/idea-bet.live/theme/ufa7/images/deposit/icn-manual-deposit.svg" />
                                                        </div>
                                                        <div className="flex flex-row ml-4 w-full">
                                                            <div className="flex flex-col w-full">
                                                                <div className="flex items-center">
                                                                    <span className="text-[#FBDEB2] font-semibold">แจ้งสลิป</span>
                                                                </div>
                                                                <span className="text-white text-xs mt-1">ทำรายการเมื่อยอดเงินไม่เข้าเกิน 5 นาที เท่านั้น</span>
                                                                <div className="flex flex-row gap-2 mt-2">
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">ขั้นต่ำ: 1</span>
                                                                    <span className="text-[10px] text-[#FBDEB2] bg-black/30 rounded px-2 py-[1px]">~3 min</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}

                                {/* ===== STEP 2: กรอกยอด + เลือกบัญชี (ผูก confirmdeposit เดิม) ===== */}
                                {(this.state.depositstep === 1 && !this.state.qrcodecheck) && (() => {
                                    const m = this.state.mainacc;
                                    const fmt = (a) => (a && a.length >= 10) ? (a.substring(0, 3) + "-" + a.substring(3, 9) + "-" + a.substring(9)) : (a || '');
                                    const hasPay = this.state.paymentgateway != null;   // เปิด payment gateway ไหม
                                    const method = this.state.depositmethod || (hasPay ? 'qr' : 'bank');
                                    const copyAcc = () => { if (m && m.accnumber) { navigator.clipboard.writeText(m.accnumber); this.notify && this.notify('success', 'คัดลอกเลขบัญชีแล้ว'); } };
                                    // ===== ทรูมันนี่ วอลเล็ท =====
                                    if (method === 'true') {
                                        const t = this.state.trueaccount || {};
                                        const copyTrue = () => { if (t.telnumber) { navigator.clipboard.writeText(t.telnumber); this.notify && this.notify('success', 'คัดลอกเบอร์แล้ว'); } };
                                        return (
                                            <div>
                                                <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2]">
                                                    <span role="button" onClick={() => this.setState({ depositstep: 0 })} className="cursor-pointer text-xl">‹</span>
                                                    <span className="text-sm">ทรูมันนี่ วอลเล็ท</span>
                                                    <span className="w-4"></span>
                                                </div>
                                                <div className="mx-4 mt-2 rounded-2xl p-4 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)', border: '1px solid #3a3a3a' }}>
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-white font-bold text-sm rounded px-2 py-[2px]" style={{ background: '#ff6a00' }}>true</span>
                                                        <span className="text-[#CDCDCD] text-xs">TrueMoney Wallet</span>
                                                    </div>
                                                    <div className="text-[#F5F5F5] text-sm mt-3">{t.name || ''}</div>
                                                    <div className="flex items-center gap-2 mt-1">
                                                        <span className="text-[#F5F5F5] text-xl tracking-wider">{t.telnumber || ''}</span>
                                                        <span role="button" onClick={copyTrue} className="text-[11px] text-black rounded px-2 py-[1px]" style={{ background: 'linear-gradient(270deg,#8b6832,#fcdd9a)' }}>คัดลอก</span>
                                                    </div>
                                                </div>
                                                <div className="mx-4 mt-4">
                                                    <div className="text-[#FBDEB2] text-sm mb-2">จำนวนเงินที่โอน</div>
                                                    <div className="flex items-center rounded-xl bg-[#00000080] border border-[#3a3a3a] px-3 h-[48px]">
                                                        <input inputMode="numeric" placeholder="0" value={this.state.depositamount || ''} onChange={(e) => this.setState({ depositamount: e.target.value.replace(/[^0-9]/g, '') })} className="flex-1 bg-transparent border-none focus:outline-none text-[#F5F5F5] text-base" />
                                                        <span className="text-[#8A7349] text-xs">บาท</span>
                                                    </div>
                                                </div>
                                                <div className="mx-4 mt-5">
                                                    <button onClick={() => this.setState({ depositstep: 0 })} className="rounded-xl w-full h-[48px] font-semibold" style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}>เสร็จสิ้น</button>
                                                </div>
                                                <div className="mx-4 mt-6">
                                                    <div className="text-sm mb-2 font-bold" style={{ color: '#ECCA77' }}>คำแนะนำ</div>
                                                    {['โอน TrueMoney Wallet ไปยังเบอร์ด้านบนตามยอดที่ต้องการฝาก', 'ระบบจะตรวจสอบและเติมเครดิตให้โดยอัตโนมัติ'].map((tx, i) => (
                                                        <div key={i} className="flex items-start mb-2"><span className="mr-2 flex-shrink-0" style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginTop: 6 }}></span><span className="text-[#CDCDCD] text-xs">{tx}</span></div>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    }
                                    // หลังกด "ฝากจากบัญชี" → โชว์บัญชีให้โอน + คัดลอก + อัพสลิป
                                    if (method === 'bank' && this.state.depositstate === 1) {
                                        return (
                                            <div>
                                                <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2]">
                                                    <span role="button" onClick={() => this.setState({ depositstate: 0 })} className="cursor-pointer text-xl">‹</span>
                                                    <span className="text-sm">โอนเงินไปยังบัญชี</span>
                                                    <span className="w-4"></span>
                                                </div>
                                                <div className="mx-4 mt-2 rounded-2xl p-4 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)', border: '1px solid #3a3a3a' }}>
                                                    {m && m.img_path && (<img src={m.img_path} className="absolute top-3 right-3 w-10 h-10 object-contain rounded" />)}
                                                    <div className="text-[#CDCDCD] text-xs">{m ? (m.fullname_th + ' (THB)') : ''}</div>
                                                    <div className="flex items-center gap-2 mt-1">
                                                        <span className="text-[#F5F5F5] text-xl tracking-wider">{m ? fmt(m.accnumber) : ''}</span>
                                                        <button onClick={copyAcc} className="text-[11px] text-black rounded px-2 py-[2px]" style={{ background: 'linear-gradient(270deg,#8b6832,#fcdd9a)' }}>คัดลอก</button>
                                                    </div>
                                                    <div className="text-[#CDCDCD] text-xs mt-1">{m ? ((m.first_name_en || '') + ' ' + (m.last_name_en || '')) : ''}</div>
                                                </div>
                                                <div className="mx-4 mt-3 rounded-xl bg-[#2a2a2a] border border-[#3a3a3a] p-3 text-center">
                                                    <div className="text-[#888] text-xs">กรุณาโอนตามยอด</div>
                                                    <div className="text-[#FBDEB2] text-2xl font-bold mt-1">฿ {(Number(this.state.depositamount) || 0).toLocaleString()}</div>
                                                </div>
                                                <div className="mx-4 mt-3 text-[#CDCDCD] text-xs">โอนเงินตรงตามยอดและแนบสลิปเพื่อให้ระบบเติมเงินได้รวดเร็วยิ่งขึ้น</div>
                                                <div className="mx-4 mt-4 flex gap-3">
                                                    <button onClick={() => this.setState({ depositstate: 0, depositstep: 0 })} className="flex-1 rounded-xl h-[48px] font-semibold text-white" style={{ background: '#3a3a3a' }}>เสร็จสิ้น</button>
                                                    {(m && m.autoslip == 1) && (<button onClick={(e) => this.checkurl(e, "/uploadslip")} className="flex-1 rounded-xl h-[48px] font-semibold" style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}>แนบสลิป</button>)}
                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                    <div>
                                        <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2]">
                                            <span role="button" onClick={() => this.setState({ depositstep: 0 })} className="cursor-pointer text-xl">‹</span>
                                            <span className="text-sm">{method === 'bank' ? 'ฝากปกติ' : 'สแกนจ่าย'}</span>
                                            <span className="w-4"></span>
                                        </div>
                                        <div className="mx-4 mt-3">
                                            {/* การ์ดบัญชีรับเงิน — โครงสร้าง ufa7 ต้นฉบับ */}
                                            <div className="bank-account-box-container flex flex-col relative" container-style="1">
                                                <div className="h-[24px]">
                                                    <div className="custom-tag w-[95px]">ไปที่บัญชี</div>
                                                </div>
                                                <div className="top-2 right-2 absolute">
                                                    <div className="custom-bank-logo-container flex justify-center items-center">
                                                        {m && m.img_path && (<img className="mx-1 max-h-[26px]" src={m.img_path} alt="logo" />)}
                                                    </div>
                                                </div>
                                                <div className="flex flex-col mx-4 mb-3">
                                                    <div className="text-[10px] mt-10" style={{ color: 'rgb(251, 222, 178)' }}>{m ? (m.fullname_th + ' (THB)') : 'กำลังโหลดบัญชี...'}</div>
                                                    <div className="text-[18px] text-white font-medium">
                                                        <div className="inline-block mb-[2px]">
                                                            <div className="flex flex-row items-center gap-2">
                                                                {m ? m.accnumber : ''}
                                                                {method === 'bank' && m && (<span role="button" onClick={copyAcc} className="text-[11px] text-black rounded px-2 py-[1px]" style={{ background: 'linear-gradient(270deg,#8b6832,#fcdd9a)' }}>คัดลอก</span>)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-[12px] text-[#EFEFEF] font-normal uppercase mb-2">{m ? ((m.first_name_en || '') + ' ' + (m.last_name_en || '')) : ''}</div>
                                                    {(this.state.listacc && this.state.listacc.length > 1) && (
                                                        <div className="absolute right-3 cursor-pointer bottom-3" onClick={() => this.setState({ bankselectopen: true })}>
                                                            <div className="custom-round-btn-box w-[39px] h-[39px] rounded-full flex p-0 m-0 b-0 cursor-pointer items-center justify-center" style={{ background: 'rgba(40,40,40,0.75)' }}>
                                                                <img className="p-2" src="/idea-bet.live/theme/ufa7/images/layout/icn-refresh.svg" alt="icn" />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* bottom sheet เลือกบัญชี (เปิดด้วยปุ่ม refresh) */}
                                        {this.state.bankselectopen && (
                                            <>
                                                <div className="overlay overlaybankselect" onClick={() => this.setState({ bankselectopen: false })} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 40 }}></div>
                                                <div className="bg-[#1E1E1E] select-bank-bottom-container mx-auto max-w-[436px] fixed bottom-0 left-0 right-0" style={{ height: '70%', zIndex: 50, borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
                                                    <div className="flex flex-col h-full pt-4">
                                                        <div className="flex justify-between">
                                                            <div className="ml-4 text-white text-sm">กรุณาเลือกบัญชี</div>
                                                            <div className="mr-4 cursor-pointer text-white" onClick={() => this.setState({ bankselectopen: false })}>✕</div>
                                                        </div>
                                                        <div className="flex-1 overflow-y-auto my-2">
                                                            <div className="text-white"><span className="mx-4 text-xs">THB - บาท</span></div>
                                                            {(this.state.listacc || []).map((acc, i) => {
                                                                const selected = m && acc.accnumber === m.accnumber;
                                                                return (
                                                                    <div key={i} className="mx-4 my-3 cursor-pointer" onClick={() => this.setState({ mainacc: acc, bankselectopen: false })}>
                                                                        <div className={"bank-account-box-container flex flex-col relative " + (selected ? 'ring-1 ring-[#FBDEB2]' : '')}>
                                                                            <div className="h-[24px]">
                                                                                {selected && (<div className="custom-tag w-[55px]">เลือกแล้ว</div>)}
                                                                            </div>
                                                                            <div className="top-2 right-2 absolute">
                                                                                <div className="custom-bank-logo-container flex justify-center items-center">
                                                                                    {acc.img_path && (<img className="mx-1 max-h-[26px]" src={acc.img_path} alt="logo" />)}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex flex-col mx-4 mb-3">
                                                                                <div className="text-[10px] mt-10" style={{ color: 'rgb(251, 222, 178)' }}>{acc.fullname_th + ' (THB)'}</div>
                                                                                <div className="text-[18px] text-white font-medium">{acc.accnumber}</div>
                                                                                <div className="text-[12px] text-[#EFEFEF] font-normal uppercase mb-2">{(acc.first_name_en || '') + ' ' + (acc.last_name_en || '')}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        <div className="flex justify-center gap-4 px-4 pb-6">
                                                            <a role="button" onClick={() => Swal.fire({ title: 'ยังไม่เปิดให้บริการ', text: 'ระบบเพิ่มบัญชีธนาคารกำลังจะเปิดให้บริการเร็ว ๆ นี้', icon: 'info', confirmButtonText: 'ตกลง' })} className="w-1/2">
                                                                <div className="rounded-xl w-full flex items-center justify-center font-normal text-sm border border-[#FDD387] text-[#FDD387] h-[49px]">เพิ่มบัญชีธนาคาร</div>
                                                            </a>
                                                            <div className="w-1/2" role="button" onClick={() => this.setState({ bankselectopen: false })}>
                                                                <div className="rounded-xl w-full flex items-center justify-center font-normal text-sm border border-[#FDD387] text-[#FDD387] h-[49px]">ยกเลิก</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className="mx-4 mt-4">
                                            <div className="text-[#FBDEB2] text-sm mb-2">กรุณากรอกยอดที่ต้องการฝาก</div>
                                            <div className="flex items-center rounded-xl bg-[#00000080] border border-[#3a3a3a] px-3 h-[48px]">
                                                <input
                                                    inputMode="numeric"
                                                    placeholder="0"
                                                    value={this.state.depositamount || ''}
                                                    onChange={(e) => this.setState({ depositamount: e.target.value.replace(/[^0-9]/g, '') })}
                                                    className="flex-1 bg-transparent border-none focus:outline-none text-[#F5F5F5] text-base"
                                                />
                                                <span className="text-[#8A7349] text-xs">บาท</span>
                                            </div>
                                            <div className="flex gap-2 mt-3">
                                                {[100, 500, 1000, 2000].map((v) => (
                                                    <button key={v} onClick={() => this.setState({ depositamount: (Number(this.state.depositamount) || 0) + v })} className="flex-1 rounded-lg bg-[#2a2a2a] border border-[#3a3a3a] text-[#FBDEB2] text-xs h-[34px]">+{v.toLocaleString()}</button>
                                                ))}
                                                <button onClick={() => this.setState({ depositamount: 0 })} className="rounded-lg bg-black text-white text-xs h-[34px] px-3">Clear</button>
                                            </div>
                                            <div className="text-[#CDCDCD] text-xs mt-2">** ฝากขั้นต่ำ {(this.state.limit && this.state.limit.min) || 100} THB สูงสุด {((this.state.limit && this.state.limit.max) || 100000).toLocaleString()} THB</div>
                                        </div>
                                        <div className="mx-4 mt-5">
                                            <button
                                                onClick={(e) => this.confirmdeposit(e, method === 'bank' ? 1 : 0)}
                                                className="rounded-xl w-full h-[48px] flex items-center justify-center font-semibold"
                                                style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)', border: '1px solid #ECCA77' }}
                                            >
                                                <span className="text-[14px] font-semibold">ต่อไป</span>
                                            </button>
                                        </div>
                                        <div className="mx-4 mt-6">
                                            <div className="text-sm mb-2 font-bold" style={{ color: '#ECCA77' }}>คำแนะนำการฝากเงิน</div>
                                            {(method === 'qr' ? [
                                                'ชื่อบัญชีธนาคารเป็นชื่อของท่านและตรงกับชื่อที่ได้ลงทะเบียนไว้',
                                                'ฝากเงินตรงตามยอดที่ระบบระบุ เท่านั้น หากยอดมีทศนิยมไม่ต้องปัดเศษ',
                                                'ทุกการฝากต้องทำรายการใหม่ทุกครั้ง',
                                                'การชำระด้วย QR Code ใช้ได้ 1 ครั้ง (ห้ามใช้ซ้ำ)',
                                                'แนะนำหลีกเลี่ยงช่วงเวลา 23:00 - 02:00 น.',
                                            ] : [
                                                'ชื่อบัญชีธนาคารเป็นชื่อของท่านและตรงกับชื่อที่ได้ลงทะเบียนไว้',
                                                'โอนเงินไปยังบัญชีที่แสดงด้านบน เท่านั้น',
                                                'ฝากเงินตรงตามยอดที่ท่านระบุ หากยอดมีทศนิยมไม่ต้องปัดเศษ',
                                                'ทุกการฝากต้องทำรายการใหม่ทุกครั้ง',
                                                'แนะนำหลีกเลี่ยงช่วงเวลา 23:00 - 02:00 น.',
                                            ]).map((t, i) => (
                                                <div key={i} className="flex items-start mb-2">
                                                    <span className="mr-2 flex-shrink-0" style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginTop: 6 }}></span>
                                                    <span className="text-[#CDCDCD] text-sm">{t}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    );
                                })()}

                                {/* ===== STEP 3: ผลลัพธ์ฝาก — รองรับ payment gateway (ลิงก์) และ QR รูป ===== */}
                                {this.state.qrcodecheck && (() => {
                                    const isRedirect = this.state.paymentLink && /^https?:\/\//.test(this.state.paymentLink);
                                    return (
                                    <div>
                                        <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2]">
                                            <span role="button" onClick={() => this.cancleqrcode()} className="cursor-pointer text-xl">‹</span>
                                            <span className="text-sm">{isRedirect ? 'รอดำเนินการ' : 'สแกนจ่าย QR'}</span>
                                            <span className="w-4"></span>
                                        </div>
                                        {isRedirect ? (
                                            <div className="px-4 mt-2 text-center">
                                                <div className="text-5xl">⏳</div>
                                                <div className="text-[#f59e0b] text-lg font-bold mt-2">รอดำเนินการ</div>
                                                <div className="rounded-2xl bg-[#2a2a2a] border border-[#3a3a3a] p-4 mt-4 text-left">
                                                    <div className="flex items-center justify-between py-1 border-b border-white/10">
                                                        <span className="text-[#888] text-xs">จำนวนเงิน</span>
                                                        <span className="text-[#FBDEB2] text-2xl font-bold">฿ {(Number(this.state.depositamount) || 0).toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex items-center justify-between py-2">
                                                        <span className="text-[#888] text-xs">สถานะ</span>
                                                        <span className="text-[#f59e0b] text-xs font-semibold">รอดำเนินการ</span>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col gap-3 mt-5">
                                                    <button onClick={() => window.open(this.state.paymentLink, '_blank', 'noopener,noreferrer')} className="rounded-xl h-[48px] font-semibold text-white" style={{ background: 'linear-gradient(135deg,#0a5ebd,#04a9c2)' }}>🔗 เปิดลิงก์ชำระเงินอีกครั้ง</button>
                                                    <button onClick={() => this.confirmqrcode()} className="rounded-xl h-[48px] font-semibold" style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}>✅ โอนเสร็จสิ้น</button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className="mx-4 mt-2 rounded-2xl bg-white p-4 flex flex-col items-center">
                                                    {this.state.qrcode && (<img src={this.state.qrcode} alt="qrcode" className="w-[240px] h-[240px] object-contain" />)}
                                                    <div className="text-black text-lg font-bold mt-3">{(Number(this.state.depositamount) || 0).toLocaleString()} บาท</div>
                                                </div>
                                                <div className="mx-4 mt-3 text-center text-[#CDCDCD] text-xs">กรุณาสแกน QR ภายใน 5 นาที และฝากตามยอดที่ระบุเท่านั้น</div>
                                                <div className="mx-4 mt-5 flex gap-3">
                                                    <button onClick={() => this.cancleqrcode()} className="flex-1 rounded-xl h-[48px] font-semibold text-white" style={{ background: '#3a3a3a' }}>ยกเลิก</button>
                                                    <button onClick={() => this.confirmqrcode()} className="flex-1 rounded-xl h-[48px] font-semibold" style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}>ฝากแล้ว</button>
                                                </div>
                                            </div>
                                        )}
                                        <div className="mx-4 mt-4 rounded-xl bg-[#3a2a14] border border-[#7a5a2a] p-3 text-[#FBDEB2] text-xs">⚠ ห้ามใช้ QR / ลิงก์นี้ซ้ำ — กรุณาชำระเงินภายใน 10 นาที เพื่อให้ระบบเติมเงินอัตโนมัติ</div>
                                    </div>
                                    );
                                })()}
                            </div>
                        )}
                        {this.state.tabselect === 2 && (
                            <div className="bg-[#1E1E1E] min-h-full pb-[120px]">
                                <div className="relative custom-container pt-3">
                                    <div className="profile-tab flex justify-around items-center text-sm">
                                        <a role="button" onClick={(e) => this.checkurl(e, "/deposit")}>
                                            <div className="cursor-pointer pb-2">ฝาก</div>
                                        </a>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/withdraw")}>
                                            <div className="cursor-pointer pb-2 tab-line text-[#FBDEB2]">ถอน</div>
                                        </a>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/history")}>
                                            <div className="cursor-pointer pb-2">ประวัติ</div>
                                        </a>
                                    </div>
                                </div>
                                <div className="withdrawal-input-container mt-4 pt-2">
                                    <div className="mx-4 mt-4">
                                        <div className="mb-3 text-xs text-[#fbdeb2]">จำนวนเครดิตที่ต้องการถอน</div>
                                        <div className="amount-input-container flex flex-row items-center rounded-xl bg-[#00000080] px-3">
                                            <input
                                                className="uf-text-input-base flex-1 h-[44px] bg-transparent border-none focus:outline-none text-[#F5F5F5]"
                                                inputMode="numeric"
                                                placeholder="0"
                                                value={this.state.withdrawamount || ''}
                                                onChange={(e) => this.setState({ withdrawamount: e.target.value })}
                                            />
                                            <div className="ml-auto text-[#8A7349] text-xs">บาท</div>
                                        </div>
                                        <div className="text-center text-xs text-[#CDCDCD] mt-2">ยอดถอนได้ {balance} บาท</div>
                                    </div>
                                </div>
                                <div className="mx-4 mt-6 border-t border-white/10"></div>
                                <div className="mx-4 mt-4">
                                    <div className="text-xs text-[#fbdeb2] mb-2">ถอนไปยัง</div>
                                    {(() => {
                                        const wa = (accnumber && accnumber.length) ? accnumber[this.state.wdaccidx || 0] : accnumberx;
                                        const clean = (x) => x && x !== 'undefined' && x !== 'null' ? x : '';
                                        const tp = this.state.tblprofile || {};
                                        const holder = [clean(firstname), clean(lastname)].filter(Boolean).join(' ')
                                            || [clean(tp.firstname), clean(tp.lastname)].filter(Boolean).join(' ')
                                            || clean(this.state.fname)
                                            || usercheck;
                                        return (
                                            <div className="bank-account-box-container flex flex-col relative" container-style="1">
                                                <div className="h-[24px]">
                                                    <div className="custom-tag w-[95px]">ไปที่บัญชี</div>
                                                </div>
                                                <div className="top-2 right-2 absolute">
                                                    <div className="custom-bank-logo-container flex justify-center items-center">
                                                        {wa && wa.img_path && (<img className="mx-1 max-h-[26px]" src={wa.img_path} alt="logo" />)}
                                                    </div>
                                                </div>
                                                <div className="flex flex-col mx-4 mb-3">
                                                    <div className="text-[10px] mt-10" style={{ color: 'rgb(251, 222, 178)' }}>{wa && wa.fullname_th ? (wa.fullname_th + ' (THB)') : 'ธนาคาร'}</div>
                                                    <div className="text-[18px] text-white font-medium">{wa && wa.accno ? wa.accno : username}</div>
                                                    <div className="text-[12px] text-[#EFEFEF] font-normal uppercase mb-2">{holder}</div>
                                                    {(accnumber && accnumber.length > 1) && (
                                                        <div className="absolute right-3 cursor-pointer bottom-3" onClick={() => this.setState({ wdbankopen: true })}>
                                                            <div className="custom-round-btn-box w-[39px] h-[39px] rounded-full flex p-0 m-0 b-0 cursor-pointer items-center justify-center">
                                                                <img className="p-2" src="/idea-bet.live/theme/ufa7/images/layout/icn-refresh.svg" alt="icn" />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })()}
                                    {/* bottom sheet เลือกบัญชีถอน */}
                                    {this.state.wdbankopen && (
                                        <>
                                            <div className="overlay overlaybankselect" onClick={() => this.setState({ wdbankopen: false })} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 40 }}></div>
                                            <div className="bg-[#1E1E1E] select-bank-bottom-container mx-auto max-w-[436px] fixed bottom-0 left-0 right-0" style={{ height: '70%', zIndex: 50, borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
                                                <div className="flex flex-col h-full pt-4">
                                                    <div className="flex justify-between">
                                                        <div className="ml-4 text-white text-sm">กรุณาเลือกบัญชี</div>
                                                        <div className="mr-4 cursor-pointer text-white" onClick={() => this.setState({ wdbankopen: false })}>✕</div>
                                                    </div>
                                                    <div className="flex-1 overflow-y-auto my-2">
                                                        <div className="text-white"><span className="mx-4 text-xs">THB - บาท</span></div>
                                                        {(accnumber || []).map((acc, i) => {
                                                            const selected = (this.state.wdaccidx || 0) === i;
                                                            return (
                                                                <div key={i} className="mx-4 my-3 cursor-pointer" onClick={() => this.setState({ wdaccidx: i, wdbankopen: false })}>
                                                                    <div className={"bank-account-box-container flex flex-col relative " + (selected ? 'ring-1 ring-[#FBDEB2]' : '')}>
                                                                        <div className="h-[24px]">{selected && (<div className="custom-tag w-[55px]">เลือกแล้ว</div>)}</div>
                                                                        <div className="top-2 right-2 absolute">
                                                                            <div className="custom-bank-logo-container flex justify-center items-center">
                                                                                {acc.img_path && (<img className="mx-1 max-h-[26px]" src={acc.img_path} alt="logo" />)}
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex flex-col mx-4 mb-3">
                                                                            <div className="text-[10px] mt-10" style={{ color: 'rgb(251, 222, 178)' }}>{acc.fullname_th + ' (THB)'}</div>
                                                                            <div className="text-[18px] text-white font-medium">{acc.accno}</div>
                                                                            <div className="text-[12px] text-[#EFEFEF] font-normal uppercase mb-2">{[firstname, lastname].filter((x) => x && x !== 'undefined' && x !== 'null').join(' ') || usercheck}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="flex justify-center gap-4 px-4 pb-6">
                                                        <a role="button" onClick={(e) => this.checkurl(e, "/addbank")} className="w-1/2">
                                                            <div className="rounded-xl w-full flex items-center justify-center font-normal text-sm border border-[#FDD387] text-[#FDD387] h-[49px]">เพิ่มบัญชีธนาคาร</div>
                                                        </a>
                                                        <div className="w-1/2" role="button" onClick={() => this.setState({ wdbankopen: false })}>
                                                            <div className="rounded-xl w-full flex items-center justify-center font-normal text-sm border border-[#FDD387] text-[#FDD387] h-[49px]">ยกเลิก</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="mx-4 mt-6">
                                    <button
                                        onClick={(e) => this.submitwithdraw(e)}
                                        className="btn-primary rounded-xl w-full h-[44px] flex items-center justify-center font-semibold"
                                        style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)', border: '1px solid #ECCA77' }}
                                    >
                                        <span className="text-[14px] font-semibold">ถอน</span>
                                    </button>
                                </div>
                                <div className="mx-4 mt-6 mb-6">
                                    <div className="text-sm mb-2 font-bold" style={{ color: '#ECCA77' }}>คำแนะนำการถอนเงิน</div>
                                    <div className="flex items-start">
                                        <span className="mr-2 flex-shrink-0" style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginTop: 6 }}></span>
                                        <span className="text-[#CDCDCD] text-sm">ชื่อบัญชีธนาคารต้องเป็นชื่อของท่านและตรงกับที่ลงทะเบียนไว้เท่านั้น</span>
                                    </div>
                                    <div className="flex items-start mt-2">
                                        <span className="mr-2 flex-shrink-0" style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginTop: 6 }}></span>
                                        <span className="text-[#CDCDCD] text-sm">ระบบจะตรวจสอบยอดเทิร์นก่อนโอนเงินให้ท่าน หากเกิน 30 นาทีกรุณาติดต่อเจ้าหน้าที่</span>
                                    </div>
                                    <div className="flex items-start mt-2">
                                        <span className="mr-2 flex-shrink-0" style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginTop: 6 }}></span>
                                        <span className="text-[#CDCDCD] text-sm">แนะนำหลีกเลี่ยงช่วงเวลา 23:00 - 02:00 น. ของวันถัดไป (ช่วงธนาคารปิดปรับปรุง)</span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.tabselect === 3 && (
                            <div className="bg-[#1E1E1E] min-h-full pb-[120px]">
                                <div className="relative custom-container pt-3">
                                    <div className="profile-tab flex justify-around items-center text-sm">
                                        <a role="button" onClick={(e) => this.checkurl(e, "/deposit")}>
                                            <div className="cursor-pointer pb-2">ฝาก</div>
                                        </a>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/withdraw")}>
                                            <div className="cursor-pointer pb-2">ถอน</div>
                                        </a>
                                        <a role="button" onClick={(e) => this.checkurl(e, "/history")}>
                                            <div className="cursor-pointer pb-2 tab-line text-[#FBDEB2]">ประวัติ</div>
                                        </a>
                                    </div>
                                </div>
                                <div className="mx-4 mt-4">
                                    <div className="text-[#FBDEB2] text-sm mb-2">ประวัติการทำรายการ</div>
                                    {(() => {
                                        const opts = [{ v: 'all', l: 'ทั้งหมด' }, { v: 'DE', l: 'ฝาก' }, { v: 'WD', l: 'ถอน' }, { v: 'BN', l: 'โบนัส' }];
                                        const cur = this.state.historyfilter || 'all';
                                        const curLabel = (opts.find((o) => o.v === cur) || opts[0]).l;
                                        return (
                                            <div className="relative w-full z-20">
                                                <div
                                                    onClick={() => this.setState({ historydropopen: !this.state.historydropopen })}
                                                    className="flex flex-row justify-between items-center cursor-pointer px-4 h-[41px]"
                                                    style={{ border: '2px solid rgba(251, 222, 177, 0.5)', borderRadius: '10px', color: '#ECCA77' }}
                                                >
                                                    <span className="text-sm">{curLabel}</span>
                                                    <span className="text-[#FBDEB2] text-xs">▾</span>
                                                </div>
                                                {this.state.historydropopen && (
                                                    <div className="drop-down-box w-full mt-1 absolute left-0" style={{ background: 'linear-gradient(270deg, rgb(3,3,2), rgb(45,45,45))', border: '1px solid #FBDEB2', borderRadius: '10px', overflow: 'hidden' }}>
                                                        {opts.map((o) => {
                                                            const sel = cur === o.v;
                                                            return (
                                                                <div
                                                                    key={o.v}
                                                                    onClick={() => this.setState({ historyfilter: o.v, historydropopen: false })}
                                                                    className="flex flex-row items-center h-[38px] cursor-pointer text-sm"
                                                                >
                                                                    <div className="w-[44px] flex justify-center" style={{ color: '#fff' }}>{sel ? '✓' : ''}</div>
                                                                    <div style={{ color: sel ? '#FFFFFF' : '#FDD387' }}>{o.l}</div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </div>
                                <div className="mx-4 mt-4">
                                    <div className="flex items-center bg-[#2a2a2a] rounded-t-md px-3 py-2 text-[#FBDEB2] text-xs">
                                        <div className="flex-1">วันที่</div>
                                        <div className="flex-1">ประเภท</div>
                                        <div className="flex-1">สถานะ</div>
                                        <div className="flex-1 text-right">ยอด</div>
                                    </div>
                                    {(() => {
                                        const all = this.state.historylist || [];
                                        const list = all.filter((it) => {
                                            const f = this.state.historyfilter || 'all';
                                            if (f === 'all') return true;
                                            if (f === 'DE') return it.type === 'DE';
                                            if (f === 'BN') return it.type === 'BN';
                                            if (f === 'WD') return it.type !== 'DE' && it.type !== 'BN';
                                            return true;
                                        });
                                        if (list.length === 0) {
                                            return (
                                                <div className="flex flex-col items-center justify-center mt-20">
                                                    <img src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-history.svg" className="w-14 h-14 opacity-80 mb-3" alt="empty" />
                                                    <div className="text-center text-lg font-semibold" style={{ color: '#FBDEB2' }}>ไม่พบรายการ</div>
                                                </div>
                                            );
                                        }
                                        const stxt = (s) => {
                                            const m = { '1': ['FINISHED', '#22c55e'], '0': ['PENDING', '#f5b301'], '2': ['PROCESSING', '#f5b301'], '4': ['CANCELED', '#ef4444'], '5': ['FAILED', '#ef4444'] };
                                            return m[String(s)] || [String(s || ''), '#CDCDCD'];
                                        };
                                        return list.map((it, i) => {
                                            const [stext, scolor] = stxt(it.status);
                                            const isDep = it.type === 'DE';
                                            return (
                                                <div key={i} className="flex items-center px-3 py-3 border-b border-white/10">
                                                    <div className="flex-1 text-[#F5F5F5] text-xs">
                                                        <div>{moment(it.createdate).format('DD MMM YY')}</div>
                                                        <div className="text-[#888]">{moment(it.createdate).format('hh:mm A (ddd)')}</div>
                                                    </div>
                                                    <div className="flex-1 text-xs" style={{ color: isDep ? '#22c55e' : '#ef4444' }}>{isDep ? 'DEPOSIT' : 'WITHDRAW'}</div>
                                                    <div className="flex-1 text-xs" style={{ color: scolor }}>{stext}</div>
                                                    <div className="flex-1 text-right text-[#F5F5F5] text-xs">{it.amount} ฿</div>
                                                </div>
                                            );
                                        });
                                    })()}
                                </div>
                            </div>
                        )}
                        {this.state.tabselect === 8 && (
                            <div className="min-h-full bg-cover bg-center pb-[120px]" style={{ backgroundImage: "url(/idea-bet.live/theme/ufa7/images/home-bg.webp)" }}>
                                <div className="w-full h-[362px] max-h-[362px] relative d-block" style={{ background: 'url(/idea-bet.live/theme/ufa7/images/top-1.webp) 0px 0px / 100% no-repeat' }}>
                                    <div className="pt-2">
                                        <table className="w-full">
                                            <tbody>
                                                <tr>
                                                    <td className="w-[33px]">
                                                        <img
                                                            className="ml-3 mb-2 w-[13px] h-[12.46px]"
                                                            src="/idea-bet.live/theme/ufa7/images/layout/icn-announcement.svg"
                                                            alt="icn"
                                                        />
                                                    </td>
                                                    <td>
                                                        <marquee behavior="scroll" direction="left">
                                                            <div className="announcement-text whitespace-nowrap font-normal text-xs">
                                                                {this.state.announcement || "📢 ช่วงเวลา 00.00 - 01.20 น. ของทุกวัน เป็นช่วงที่ธนาคารอัปเดตระบบประจำวัน อาจทำให้ช่วงเวลาดังกล่าวยอดเงินจะเข้าช้ากว่าปกติ ขออภัยในความไม่สะดวกค่ะ 🙏"}
                                                            </div>
                                                        </marquee>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="pt-4">
                                        <div className="flex flex-col text-center justify-center">
                                            <div className="text-sm text-[#FBDEB2]">ยินดีต้อนรับ,</div>
                                            <div className="text-[24px] text-center text-white">{usercheck}</div>
                                            <div className="text-sm bg-black/20 rounded-full py-1 px-3 mb-2 max-w-[280px] mx-auto text-[#ecca77]">{username}</div>
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center mt-2">
                                        <div className="flex justify-center items-center creditBalanceContainer balance-pill">
                                            <div className="m-1 content-center h-[30px] min-w-[42px] text-[#D0AE71] text-xs credit-currency-container">
                                                <span className="ml-2">บาท</span>
                                            </div>
                                            <div className="flex flex-row justify-center items-center cursor-pointer" onClick={() => this.setState({ walletopen: true })}>
                                                <div className="text-l text-[#FBDEB2] mr-2 credit-balance-container">{balance}</div>
                                                <div className="mr-4">
                                                    <img alt="chevron" src="data:image/svg+xml,%3csvg%20width='11'%20height='6'%20viewBox='0%200%2011%206'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.5%201L5.50056%205L1.5%201'%20stroke='%238C8C8C'%20stroke-width='2'%20stroke-miterlimit='10'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e" />
                                                </div>
                                            </div>
                                        </div>
                                        <a role="button" onClick={(e) => this.checkurl(e, '/deposit')}>
                                            <div className="ml-2 flex justify-center items-center currencySelectButton cursor-pointer">
                                                <img alt="deposit" src="data:image/svg+xml,%3csvg%20width='34'%20height='34'%20viewBox='0%200%2034%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='33'%20height='33'%20rx='16.5'%20fill='url(%23paint0_linear_5229_3448)'%20fill-opacity='0.45'%20stroke='%2361615F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.9997%2011.0623C16.7335%2011.0623%2016.4781%2011.1681%2016.2898%2011.3564C16.1015%2011.5446%2015.9958%2011.8003%2015.9958%2012.0666L16.0009%2016.3776L11.6895%2016.3725C11.4232%2016.3725%2011.1679%2016.4783%2010.9796%2016.6666C10.7913%2016.8549%2010.6855%2017.1102%2010.6855%2017.3765C10.6855%2017.6428%2010.7913%2017.8981%2010.9796%2018.0864C11.1679%2018.2747%2011.4235%2018.3805%2011.6898%2018.3805L16.0009%2018.3753L15.9958%2022.6867C15.9958%2022.9491%2016.0217%2022.9491%2016.0722%2023.0709C16.1227%2023.1927%2016.1966%2023.3034%2016.2898%2023.3966C16.3831%2023.4899%2016.4937%2023.5638%2016.6155%2023.6143C16.7373%2023.6647%2016.8679%2023.6907%2016.9997%2023.6907C17.1316%2023.6907%2017.2621%2023.6647%2017.3839%2023.6143C17.5057%2023.5638%2017.6164%2023.4899%2017.7097%2023.3966C17.8029%2023.3034%2017.8768%2023.1927%2017.9273%2023.0709C17.9777%2022.9491%2018.0037%2022.8183%2018.0037%2022.6864L17.9986%2018.3753L22.3095%2018.38C22.4414%2018.38%2022.5719%2018.354%2022.6937%2018.3036C22.8155%2018.2531%2022.9262%2018.1792%2023.0194%2018.086C23.1127%2017.9927%2023.1866%2017.8821%2023.2371%2017.7602C23.2875%2017.6384%2023.3135%2017.5079%2023.3135%2017.376C23.3135%2017.2442%2023.2875%2017.1136%2023.2371%2016.9918C23.1866%2016.87%2023.1127%2016.7594%2023.0194%2016.6661C22.9262%2016.5729%2022.8155%2016.499%2022.6937%2016.4485C22.5719%2016.398%2022.4411%2016.3721%2022.3092%2016.3721L17.9982%2016.3772L18.0037%2012.0663C18.0037%2011.8%2017.8979%2011.5446%2017.7097%2011.3564C17.5214%2011.1681%2017.266%2011.0623%2016.9997%2011.0623Z'%20fill='url(%23paint1_linear_5229_3448)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_5229_3448'%20x1='17'%20y1='0'%20x2='17'%20y2='34'%20gradientUnits='userSpaceOnUse'%3e%3cstop/%3e%3cstop%20offset='1'%20stop-color='%235E5544'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_5229_3448'%20x1='16.9995'%20y1='11.0623'%20x2='16.9933'%20y2='23.6907'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%238B6832'/%3e%3cstop%20offset='1'%20stop-color='%23FCDD9A'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e" />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="custom-rank-container">
                                        <div>
                                            <div className="flex-1 relative">
                                                <div className="float-right">
                                                    <a role="button" onClick={(e) => this.checkurl(e, '/rank')}>
                                                        <div
                                                            className="w-[72px] h-[38px] rounded-l-2xl shrink-0 items-center justify-center rankCustomButton cursor-pointer"
                                                            style={{ backgroundImage: 'url(/idea-bet.live/theme/ufa7/images/rank/icn-rank-button-bg.svg)' }}
                                                        >
                                                            <img className="w-[36px] h-[36px] float-left ml-2" src="/idea-bet.live/theme/ufa7/images/membership/membership-logo-1.webp" alt="icn" />
                                                            <img className="w-[14px] h-[14px] mr-2 mt-3.5 float-right" src="/idea-bet.live/theme/ufa7/images/rank/icn-rank-right-arrow.svg" alt="icn" />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="profile-menu-container">
                                    <div className="flex justify-center">
                                        <div className="profile-container px-4 w-[90%] h-full">
                                            <div className="profile-tab mt-5 flex justify-between items-center text-sm">
                                                <div onClick={() => this.setState({ profiletab: 'user' })} className={"cursor-pointer tab-personal" + ((this.state.profiletab || 'user') === 'user' ? ' tab-title' : '')}>บัญชีผู้ใช้</div>
                                                <div onClick={() => this.setState({ profiletab: 'bank' })} className={"cursor-pointer tab-account" + ((this.state.profiletab || 'user') === 'bank' ? ' tab-title' : '')}>ข้อมูลบัญชีธนาคาร</div>
                                                <div onClick={() => this.setState({ profiletab: 'setting' })} className={"cursor-pointer tab-setting" + ((this.state.profiletab || 'user') === 'setting' ? ' tab-title' : '')}>ตั้งค่า</div>
                                            </div>

                                            <div className="w-full mt-8">
                                                {/* ===== PERSONAL ===== */}
                                                <div className="profilebox personaluser" style={{ display: (this.state.profiletab || 'user') === 'user' ? 'block' : 'none' }}>
                                                    <div>
                                                        {/* Username */}
                                                        <div>
                                                            <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>ชื่อผู้ใช้ / Username</label>
                                                            <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                <div className="absolute mx-4">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-user.svg" alt="icn" />
                                                                </div>
                                                                <div className="input-label w-full ml-7">
                                                                    <input readOnly value={usercheck || ''} className="ml-7 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full min-w-[100px]" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Phone */}
                                                        <div>
                                                            <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>หมายเลขโทรศัพท์</label>
                                                            <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                <div className="ml-4 flex items-center">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/language/icn-lang-th.svg" alt="TH" className="w-[22px] h-[22px] rounded-full object-cover" />
                                                                </div>
                                                                <div className="input-label w-full ml-2">
                                                                    <input readOnly value={'+66 ' + (username || '')} className="ml-2 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* First name */}
                                                        <div>
                                                            <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>ชื่อ</label>
                                                            <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                <div className="absolute mx-4">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-user.svg" alt="icn" />
                                                                </div>
                                                                <div className="input-label w-full opacity-60 ml-7">
                                                                    <input readOnly value={(firstname && firstname !== 'undefined' && firstname !== 'null') ? firstname : ''} className="ml-7 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                </div>
                                                                <div className="relative flex flex-end mr-4 cursor-pointer">
                                                                    <img className="w-[20px] h-[20px]" src="/idea-bet.live/theme/ufa7/images/layout/icn-edit.svg" alt="edit" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Last name */}
                                                        <div>
                                                            <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>นามสกุล</label>
                                                            <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                <div className="absolute mx-4">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-user.svg" alt="icn" />
                                                                </div>
                                                                <div className="input-label w-full opacity-60 ml-7">
                                                                    <input readOnly value={(lastname && lastname !== 'undefined' && lastname !== 'null') ? lastname : ''} className="ml-7 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                </div>
                                                                <div className="relative flex flex-end mr-4 cursor-pointer">
                                                                    <img className="w-[20px] h-[20px]" src="/idea-bet.live/theme/ufa7/images/layout/icn-edit.svg" alt="edit" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Birthday */}
                                                        <div>
                                                            <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>วันเกิด</label>
                                                            <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                <div className="absolute mx-4">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-dob.svg" alt="icn" />
                                                                </div>
                                                                <div className="input-label w-full ml-7">
                                                                    <input value={this.state.birthday || ''} placeholder="dd/mm/yyyy" onChange={(e) => this.setState({ birthday: e.target.value })} className="ml-7 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                </div>
                                                                <div className="relative flex flex-end mr-4 cursor-pointer">
                                                                    <img className="w-[20px] h-[20px]" src="/idea-bet.live/theme/ufa7/images/layout/icn-edit.svg" alt="edit" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {!this.state.showchangepass ? (
                                                            <div className="w-full mt-5">
                                                                <div onClick={() => this.setState({ showchangepass: true })} className="flex flex-col relative cursor-pointer mx-auto">
                                                                    <div className="absolute mx-4 mt-3">
                                                                        <img src="/idea-bet.live/theme/ufa7/images/layout/icn-password-lock.svg" alt="lock" />
                                                                    </div>
                                                                    <a>
                                                                        <div className="btn-primary rounded-xl w-full h-[49px] flex items-center justify-center text-center mx-auto font-normal text-sm black">เปลี่ยนรหัสผ่าน</div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="w-full mt-5">
                                                                <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>รหัสผ่านเดิม</label>
                                                                <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                    <div className="input-label w-full ml-4">
                                                                        <input type="password" value={this.state.oldpassword || ''} onChange={(e) => this.setState({ oldpassword: e.target.value })} className="ml-2 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                    </div>
                                                                </div>
                                                                <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>รหัสผ่านใหม่</label>
                                                                <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                    <div className="input-label w-full ml-4">
                                                                        <input type="password" value={this.state.password || ''} onChange={(e) => this.setState({ password: e.target.value })} className="ml-2 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                    </div>
                                                                </div>
                                                                <label className="flex flex-row items-center text-[12px] mx-auto mb-2 capitalize font-extralight" style={{ color: '#fbdeb2' }}>ยืนยันรหัสผ่านใหม่</label>
                                                                <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 rounded-xl custom-button-container relative">
                                                                    <div className="input-label w-full ml-4">
                                                                        <input type="password" value={this.state.passwordcf || ''} onChange={(e) => this.setState({ passwordcf: e.target.value })} className="ml-2 rounded-xl h-[46px] text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none w-full" />
                                                                    </div>
                                                                </div>
                                                                <div className="w-full mt-5">
                                                                    <a onClick={(e) => this.resetpassword(e, 1)}>
                                                                        <div className="btn-primary rounded-xl w-full h-[49px] flex items-center justify-center text-center mx-auto font-normal text-sm black cursor-pointer">บันทึกรหัสผ่านใหม่</div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="pb-[50px]"></div>
                                                    </div>
                                                </div>

                                                {/* ===== ACCOUNT (bank) ===== */}
                                                <div className="profilebox accountuser" style={{ display: (this.state.profiletab || 'user') === 'bank' ? 'block' : 'none' }}>
                                                    <div className="w-full">
                                                        <div onClick={() => Swal.fire({ title: 'ยังไม่เปิดให้บริการ', text: 'ระบบเพิ่มบัญชีธนาคารกำลังจะเปิดให้บริการเร็ว ๆ นี้', icon: 'info', confirmButtonText: 'ตกลง' })} className="flex flex-col relative cursor-pointer mx-auto">
                                                            <div className="rounded-xl w-full flex items-center justify-center mx-auto font-normal text-sm border border-1 border-[#FDD387] h-[49px] text-[#FDD387]">เพิ่มบัญชีธนาคาร</div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {(accnumber || []).map((acc, i) => {
                                                            const holder = [firstname, lastname].filter((x) => x && x !== 'undefined' && x !== 'null').join(' ') || (usercheck || '');
                                                            return (
                                                                <div key={i} className="my-4">
                                                                    <div className="custom-cointaner flex flex-col relative min-h-[135px]">
                                                                        <div className="h-[24px]">
                                                                            {i === 0 && (<div className="custom-tag w-[55px]">Default</div>)}
                                                                        </div>
                                                                        <div className="top-2 right-2 absolute">
                                                                            <div className="custom-bank-logo-cointaner flex justify-center items-center">
                                                                                {acc.img_path && (<img src={acc.img_path} className="mx-1 max-h-[26px] object-contain" alt="logo" />)}
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex flex-col mx-4">
                                                                            <div className="text-[10px] mt-10" style={{ color: 'rgb(251, 222, 178)' }}>{acc.fullname_th}</div>
                                                                            <div className="text-[18px] text-white font-medium">{acc.accno}</div>
                                                                            <div className="text-[12px] text-[#EFEFEF] font-normal uppercase mb-2">{holder}</div>
                                                                        </div>
                                                                        <div className="absolute bottom-3 right-3 cursor-pointer">
                                                                            <svg width="28" height="28" viewBox="0 0 28 28" fill="#FCDD9A" xmlns="http://www.w3.org/2000/svg"><path d="M14 3l3.4 6.9 7.6 1.1-5.5 5.35 1.3 7.55L14 20.3l-6.8 3.6 1.3-7.55L3 11l7.6-1.1L14 3z"/></svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>

                                                {/* ===== SETTING ===== */}
                                                <div className="profilebox settingbox" style={{ display: (this.state.profiletab || 'user') === 'setting' ? 'block' : 'none' }}>
                                                    <div className="relative">
                                                        <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 mx-auto rounded-xl custom-button-container relative">
                                                            <div className="input-label ml-4 absolute" style={{ color: '#ECCA77' }}>ภาษา / Language</div>
                                                            <div className="relative flex flex-end items-center ml-auto mr-4 cursor-pointer">
                                                                <div className="flex flex-row items-center changelanguage">
                                                                    <div className="mr-3 text-white font-normal font-xs">ภาษาไทย</div>
                                                                    <div>
                                                                        <img className="w-[10px] h-[10px]" src="/idea-bet.live/theme/ufa7/images/layout/icn-right.svg" alt=">" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-row items-center text-[14px] h-[46px] mb-4 mx-auto rounded-xl custom-button-container relative">
                                                        <div className="input-label ml-4 absolute" style={{ color: '#F5F5F5' }}>โยกเครดิตอัตโนมัติ</div>
                                                        <div className="relative flex flex-end items-center ml-auto mr-4 cursor-pointer">
                                                            <div onClick={() => this.setState({ autocredit: this.state.autocredit === false ? true : false })}>
                                                                <div className={"toggle-switch" + ((this.state.autocredit !== false) ? ' checked' : '')}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="profile-setting-container">
                                                            <div className="flex text-white text-xs">
                                                                <div className="icon-container">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-check-green.svg" alt="ok" />
                                                                </div>
                                                                <div className="mt-2">สะดวก</div>
                                                            </div>
                                                            <div className="flex text-white text-xs">
                                                                <div className="icon-container">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-check-green.svg" alt="ok" />
                                                                </div>
                                                                <div className="mt-2">ไม่จำเป็นต้องโอนเครดิตเมื่อเปลี่ยนเกม</div>
                                                            </div>
                                                            <div className="flex text-white text-xs">
                                                                <div className="icon-container">
                                                                    <img src="/idea-bet.live/theme/ufa7/images/layout/icn-exclamation-mark.svg" alt="!" />
                                                                </div>
                                                                <div className="mt-2">ไม่สามารถเล่นหลายเกมพร้อมกันได้</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.tabselect === 41 && (
                            <div className="bg-[#1E1E1E] min-h-full pb-[120px]">
                                <div className="flex items-center justify-between px-4 h-[48px] text-[#FBDEB2]">
                                    <span role="button" onClick={(e) => this.checkurl(e, "/home")} className="cursor-pointer text-xl">‹</span>
                                    <span className="text-sm">ระบบ Rank</span>
                                    <span className="w-4"></span>
                                </div>
                                <div style={{ padding: "8px 16px 0", maxWidth: 900, margin: "0 auto" }}>
                                    <h1 style={{ textAlign: "center", color: "#f59e0b", fontSize: 22, marginBottom: 6 }}>ระบบ Rank</h1>
                                    <p style={{ textAlign: "center", color: "#9ca3af", fontSize: 13, marginBottom: 20 }}>สะสมคะแนนเพื่อรับรางวัล Rank พิเศษ</p>
                                    {this.state.loginstate && this.state.rankob && (
                                        <div style={{ background: "linear-gradient(135deg, #1e1b4b, #312e81)", border: "2px solid #f59e0b", borderRadius: 16, padding: "16px 18px", marginBottom: 24, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                                            <div style={{ width: 64, height: 64, borderRadius: "50%", border: "3px solid #f59e0b", overflow: "hidden", flexShrink: 0, background: "#1f2937", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                {this.state.rankpic
                                                    ? <img src={/^https?:\/\//.test(this.state.rankpic) ? this.state.rankpic : "/build/rank/" + this.state.rankpic} alt="rank" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                    : <i className="fas fa-crown" style={{ fontSize: 28, color: "#f59e0b" }} />}
                                            </div>
                                            <div style={{ flex: 1, minWidth: 160 }}>
                                                <div style={{ color: "#f59e0b", fontWeight: 700, fontSize: 16 }}>Rank ปัจจุบัน: {this.state.rankname || this.state.rankob?.name || "-"}</div>
                                                <div style={{ color: "#d1d5db", fontSize: 13, marginTop: 4 }}>คะแนนสะสม: <span style={{ color: "#fff", fontWeight: 600 }}>{(this.state.rankpoint || 0).toLocaleString()}</span> แต้ม</div>
                                                {this.state.rankob?.highamount && (
                                                    <div style={{ marginTop: 8 }}>
                                                        <div style={{ background: "#374151", borderRadius: 99, height: 8, overflow: "hidden" }}>
                                                            <div style={{ background: "linear-gradient(90deg, #f59e0b, #fbbf24)", height: "100%", width: Math.min(100, ((this.state.rankpoint - (this.state.rankob?.lowamount || 0)) / ((this.state.rankob?.highamount || 1) - (this.state.rankob?.lowamount || 0))) * 100) + "%", borderRadius: 99 }} />
                                                        </div>
                                                        <div style={{ color: "#9ca3af", fontSize: 12, marginTop: 4 }}>{(this.state.rankob?.lowamount || 0).toLocaleString()} – {(this.state.rankob?.highamount || 0).toLocaleString()} แต้ม</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.loginstate && (
                                        <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px 0" }}>
                                            <i className="fas fa-lock" style={{ fontSize: 40, color: "#374151", marginBottom: 12, display: "block" }} />
                                            กรุณาเข้าสู่ระบบเพื่อดูและรับ Rank ของคุณ
                                        </div>
                                    )}
                                    {this.state.tblrankall && this.state.tblrankall.length > 0 && (
                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
                                            {this.state.tblrankall.map((rank, i) => {
                                                const canClaim = rank.checked == 1 || rank.checked === true;
                                                const redeemed = rank.redeemed == 1 || rank.redeemed === true;
                                                const reached = this.state.rankpoint >= (rank.lowamount || 0);
                                                return (
                                                    <div key={rank.no || i} style={{ background: redeemed ? "#1a2e1a" : canClaim ? "#1e3a2e" : "#1f2937", border: `2px solid ${redeemed ? "#16a34a" : canClaim ? "#22c55e" : "#374151"}`, borderRadius: 12, padding: 14, textAlign: "center", opacity: (!reached && !redeemed) ? 0.6 : 1 }}>
                                                        <div style={{ width: 52, height: 52, borderRadius: "50%", margin: "0 auto 10px", border: `2px solid ${redeemed ? "#16a34a" : canClaim ? "#22c55e" : "#4b5563"}`, overflow: "hidden", background: "#111827", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            {rank.image
                                                                ? <img src={/^https?:\/\//.test(rank.image) ? rank.image : "/build/rank/" + rank.image} alt={rank.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                                : <i className="fas fa-medal" style={{ fontSize: 22, color: redeemed ? "#16a34a" : canClaim ? "#22c55e" : "#6b7280" }} />}
                                                        </div>
                                                        <div style={{ color: "#f3f4f6", fontWeight: 700, fontSize: 14, marginBottom: 4 }}>{rank.name || `Rank ${rank.no}`}</div>
                                                        <div style={{ color: "#9ca3af", fontSize: 12, marginBottom: 8 }}>{(rank.lowamount || 0).toLocaleString()} แต้มขึ้นไป</div>
                                                        {rank.claimamount > 0 && (
                                                            <div style={{ color: "#fbbf24", fontSize: 13, fontWeight: 600, marginBottom: 10 }}>รับโบนัส {parseFloat(rank.claimamount).toLocaleString()} บาท</div>
                                                        )}
                                                        {redeemed ? (
                                                            <div style={{ background: "#15803d", color: "#fff", borderRadius: 8, padding: "6px 0", fontSize: 13, fontWeight: 600 }}>✓ รับแล้ว</div>
                                                        ) : canClaim ? (
                                                            <button onClick={(e) => this.redeemrank(e, rank)} style={{ background: "linear-gradient(135deg, #16a34a, #22c55e)", color: "#fff", border: "none", borderRadius: 8, padding: "8px 0", width: "100%", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>🎁 กดรับ</button>
                                                        ) : (
                                                            <div style={{ background: "#374151", color: "#6b7280", borderRadius: 8, padding: "6px 0", fontSize: 13 }}>🔒 ยังไม่ถึง</div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                    {this.state.loginstate && (!this.state.tblrankall || this.state.tblrankall.length === 0) && (
                                        <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px 0" }}>ยังไม่มีข้อมูล Rank ในระบบ</div>
                                    )}
                                </div>
                            </div>
                        )}
                        {this.state.tabselect === 7 && (
                            <Promotion
                                checkurl={this.checkurl}
                                webnamex={this.state.webnamex}
                                linelink={this.state.linelink}
                                logoimg={this.state.logoimg}
                            />
                        )}
                        {this.state.tabselect === 40 && (
                            <div className="bg-[#1E1E1E] min-h-full pb-[120px]">
                                <div className="text-center text-[#FBDEB2] text-sm pt-4">uCoin เช็กอินประจำวัน</div>
                                <div className="mx-4 mt-3 rounded-2xl p-4 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #2a2118 0%, #15110c 100%)', border: '1px solid #3a2f1f' }}>
                                    <span className="absolute top-3 left-3 text-[10px] text-[#FBDEB2] bg-black/40 rounded px-2 py-[1px]">{this.state.rankname || 'Bronze'}</span>
                                    <button className="absolute top-3 right-3 text-[11px] text-[#FBDEB2] bg-black/40 rounded px-2 py-[2px]">ประวัติ ▸</button>
                                    <div className="flex items-center justify-center gap-2 mt-6">
                                        <img src="/idea-bet.live/theme/ufa7/images/layout/icn-ucoin.svg" className="w-7 h-7" />
                                        <span className="text-[#FBDEB2] text-2xl font-bold">{this.state.ucoin || '0.5'}</span>
                                    </div>
                                    <div className="flex justify-center mt-4">
                                        <button
                                            onClick={(e) => this.checkin ? this.checkin(e) : null}
                                            className="rounded-full px-10 h-[44px] font-semibold"
                                            style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}
                                        >เช็กอินเลย!</button>
                                    </div>
                                </div>
                                <div className="text-center text-[#FBDEB2] text-sm mt-5">แลก uCoin</div>
                                <div className="mx-4 mt-3 flex gap-2">
                                    <div className="flex-1 flex items-center rounded-xl bg-[#00000080] border border-[#3a3a3a] px-3 h-[44px]">
                                        <input
                                            value={this.state.rewardsearch || ''}
                                            onChange={(e) => this.setState({ rewardsearch: e.target.value })}
                                            placeholder="ค้นหา"
                                            className="flex-1 bg-transparent border-none focus:outline-none text-[#F5F5F5] text-sm"
                                        />
                                        <span className="text-[#FBDEB2]">⌕</span>
                                    </div>
                                    <select
                                        value={this.state.rewardsort || 'Default'}
                                        onChange={(e) => this.setState({ rewardsort: e.target.value })}
                                        className="rounded-xl bg-[#00000080] border border-[#3a3a3a] text-[#F5F5F5] text-sm px-3 h-[44px] focus:outline-none"
                                    >
                                        <option style={{ color: '#000' }}>Default</option>
                                        <option style={{ color: '#000' }}>Coin ↑</option>
                                        <option style={{ color: '#000' }}>Coin ↓</option>
                                    </select>
                                </div>
                                <div className="mx-4 mt-3 flex text-sm border-b border-white/10">
                                    {['ALL', 'Tickets', 'Products'].map((t) => (
                                        <div
                                            key={t}
                                            role="button"
                                            onClick={() => this.setState({ rewardtab: t })}
                                            className={"cursor-pointer pb-2 mr-6 " + ((this.state.rewardtab || 'ALL') === t ? 'tab-line text-[#FBDEB2]' : 'text-white')}
                                        >{t}</div>
                                    ))}
                                </div>
                                <div className="mx-4 mt-3">
                                    {(() => {
                                        const items = this.state.rewarditems || [];
                                        const q = (this.state.rewardsearch || '').toLowerCase();
                                        const list = items.filter((it) => !q || (it.name || '').toLowerCase().includes(q));
                                        if (list.length === 0) {
                                            return (<div className="text-center text-[#888] text-sm py-10">ไม่มีรายการแลกของรางวัล</div>);
                                        }
                                        return list.map((it, i) => (
                                            <div key={i} className="flex items-center rounded-xl bg-[#2a2a2a] border border-[#3a3a3a] p-3 mb-3">
                                                <div className="w-[70px] h-[70px] rounded-lg bg-white/90 flex items-center justify-center overflow-hidden mr-3">
                                                    {it.img && (<img src={it.img} className="w-full h-full object-contain" />)}
                                                </div>
                                                <div className="flex-1">
                                                    <div className="text-[#F5F5F5] text-sm font-medium">{it.name}</div>
                                                    <div className="flex items-center gap-1 mt-1">
                                                        <img src="/idea-bet.live/theme/ufa7/images/layout/icn-ucoin.svg" className="w-4 h-4" />
                                                        <span className="text-[#FBDEB2] text-sm">{it.coins} coins</span>
                                                    </div>
                                                    <div className="text-[#888] text-[11px] mt-1">คลัง: {it.stock} / แลกได้: {it.limit}</div>
                                                </div>
                                                <div className="text-right text-[11px] text-[#ef4444] w-[80px]">{it.statustext}</div>
                                            </div>
                                        ));
                                    })()}
                                </div>
                            </div>
                        )}
                        {(this.state.tabselect === 50 || this.state.tabselect === 51) && (
                            <div className="bg-[#1E1E1E] min-h-full">
                                <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2] border-b border-white/10">
                                    <span role="button" onClick={(e) => this.checkurl(e, "/home")} className="cursor-pointer text-xl">‹</span>
                                    <span className="text-sm">{this.state.tabselect === 51 ? 'Highlight' : 'UFA News'}</span>
                                    <span className="w-4"></span>
                                </div>
                                <iframe
                                    title="ufanews"
                                    src={this.state.tabselect === 51 ? 'https://www.ufanews.digital/highlights' : 'https://www.ufanews.digital/'}
                                    className="w-full border-none"
                                    style={{ height: 'calc(100vh - 188px)' }}
                                />
                            </div>
                        )}
                        {this.state.tabselect === 52 && (
                            <div className="bg-[#1E1E1E] min-h-full pb-[120px]">
                                <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2] border-b border-white/10">
                                    <span role="button" onClick={(e) => this.checkurl(e, "/home")} className="cursor-pointer text-xl">‹</span>
                                    <span className="text-sm">แนะนำเพื่อน</span>
                                    <span className="w-4"></span>
                                </div>
                                <div className="profile-tab flex justify-around items-center text-sm pt-3">
                                    <a role="button" onClick={() => this.setState({ referraltab: 'invite' })}>
                                        <div className={"cursor-pointer pb-2 " + ((this.state.referraltab || 'invite') === 'invite' ? 'tab-line text-[#FBDEB2]' : 'text-white')}>การแนะนำ</div>
                                    </a>
                                    <a role="button" onClick={() => this.setState({ referraltab: 'friends' })}>
                                        <div className={"cursor-pointer pb-2 " + ((this.state.referraltab || 'invite') === 'friends' ? 'tab-line text-[#FBDEB2]' : 'text-white')}>เพื่อนที่แนะนำ</div>
                                    </a>
                                </div>

                                {(this.state.referraltab || 'invite') === 'invite' && (() => {
                                    const refcode = (linkaff || '').includes('=') ? linkaff.split('=').pop() : '';
                                    // รางวัลแนะนำเพื่อน — ดึงจากค่าที่ตั้งไว้ในระบบหลังบ้าน (tblinvitedsetting) โชว์เฉพาะที่เปิดใช้งาน
                                    const inv = this.state.inviteSet || {};
                                    const rewards = [];
                                    if (Number(inv.fisttimestatus) === 1 && parseFloat(inv.creditfisttime) > 0) {
                                        rewards.push({ t: `เพื่อนฝากครั้งแรก รับ ${parseFloat(inv.creditfisttime).toLocaleString()} เครดิต`, d: 'รับโบนัสทันทีเมื่อเพื่อนที่คุณแนะนำสมัครและฝากเงินครั้งแรก', c: parseFloat(inv.creditfisttime).toLocaleString() });
                                    }
                                    if (Number(inv.invitedstatus) === 1 && parseFloat(inv.creditinvited) > 0) {
                                        rewards.push({ t: `แนะนำเพื่อน รับ ${parseFloat(inv.creditinvited).toLocaleString()} เครดิต/คน`, d: 'รับโบนัสต่อเพื่อน 1 คน ที่เล่นครบตามเงื่อนไข', c: parseFloat(inv.creditinvited).toLocaleString() });
                                    }
                                    if (parseFloat(inv.depositpercent) > 0) {
                                        rewards.push({ t: `รับ ${parseFloat(inv.depositpercent)}% จากยอดฝากของเพื่อน`, d: 'รับเปอร์เซ็นต์คืนจากยอดฝากของเพื่อนที่คุณแนะนำ', c: parseFloat(inv.depositpercent) + '%' });
                                    }
                                    return (
                                        <div className="px-4">
                                            <div className="mt-4 rounded-2xl p-5 text-center relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #4a3a1f 0%, #2a2114 60%, #1a140c 100%)', border: '1px solid #8A7349' }}>
                                                <div className="text-[#FBDEB2] text-2xl font-bold">Refer &amp; Earn</div>
                                                <div className="text-[#CDCDCD] text-xs mt-2 leading-relaxed">แนะนำเพื่อนของคุณเพื่อรับโบนัสแนะนำพิเศษเมื่อเพื่อนของคุณสมัครโดยใช้รหัสอ้างอิงของคุณ</div>
                                                <div className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-full bg-[#00000080] border border-[#8A7349]">
                                                    <span className="text-[#FBDEB2] text-sm tracking-wider">{refcode || '-'}</span>
                                                    <span role="button" onClick={() => { try { navigator.clipboard.writeText(refcode); this.notify && this.notify('success', 'คัดลอกรหัสแล้ว'); } catch (e) {} }} className="cursor-pointer text-[#FBDEB2]">⧉</span>
                                                </div>
                                            </div>
                                            <div className="text-center text-[#FBDEB2] text-sm mt-5 mb-3">รางวัล</div>
                                            {rewards.map((r, i) => (
                                                <div key={i} className="flex items-center rounded-xl bg-[#2a2a2a] border border-[#3a3a3a] p-3 mb-3">
                                                    <div className="w-11 h-11 rounded-full bg-[#3a3a3a] flex items-center justify-center mr-3 flex-shrink-0">
                                                        <img src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-rewards.svg" className="w-6 h-6" />
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="text-[#F5F5F5] text-sm font-medium leading-snug">{r.t}</div>
                                                        <div className="text-[#888] text-[11px] mt-1 leading-snug">{r.d}</div>
                                                        <div className="inline-flex items-center gap-1 mt-2 px-2 py-[2px] rounded-full bg-black/40">
                                                            <img src="/idea-bet.live/theme/ufa7/images/layout/icn-ucoin.svg" className="w-4 h-4" />
                                                            <span className="text-[#FBDEB2] text-xs">{r.c}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="text-center text-[#FBDEB2] text-sm mt-5 mb-2">ประวัติ</div>
                                            <div className="rounded-xl bg-[#2a2a2a] border border-[#3a3a3a] p-4 text-center mb-3">
                                                <div className="text-[#F5F5F5] text-2xl font-bold">{this.state.afficiateall || (this.state.useradvice ? this.state.useradvice.length : 0)}</div>
                                                <div className="text-[#888] text-xs mt-1">แนะนำสำเร็จ</div>
                                            </div>
                                            <div className="text-[#FBDEB2] text-xs mb-1">ลิงค์แนะนำ</div>
                                            <div className="flex items-center rounded-xl bg-[#00000080] border border-[#3a3a3a] px-3 h-[48px]">
                                                <input readOnly value={linkaff || ''} className="flex-1 bg-transparent border-none focus:outline-none text-[#F5F5F5] text-xs" />
                                                <button
                                                    onClick={() => { try { navigator.clipboard.writeText(linkaff); this.notify && this.notify('success', 'คัดลอกลิงค์แล้ว'); } catch (e) {} }}
                                                    className="ml-2 rounded-lg px-3 h-[34px] text-[12px] font-semibold"
                                                    style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)' }}
                                                >Copy</button>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {(this.state.referraltab || 'invite') === 'friends' && (
                                    <div className="px-4 mt-4">
                                        {(this.state.useradvice || []).length === 0 ? (
                                            <div className="text-center text-[#888] text-sm py-12">ยังไม่มีเพื่อนที่แนะนำ</div>
                                        ) : (
                                            (this.state.useradvice || []).map((f, i) => (
                                                <div key={i} className="flex items-center justify-between rounded-xl bg-[#2a2a2a] border border-[#3a3a3a] p-3 mb-3">
                                                    <span className="text-[#F5F5F5] text-sm">{f.playerid || f.username}</span>
                                                    <span className="text-[#888] text-xs">{f.DateCreate ? moment(f.DateCreate).format('DD/MM/YY') : ''}</span>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {/* ===== ฝากแจ้งสลิป (tabselect 35) — ผูก uploadSlip เดิม ===== */}
                        {this.state.tabselect === 35 && (() => {
                            const m = this.state.mainacc;
                            const copyAcc = () => { if (m && m.accnumber) { navigator.clipboard.writeText(m.accnumber); this.notify && this.notify('success', 'คัดลอกเลขบัญชีแล้ว'); } };
                            return (
                            <div className="bg-[#1E1E1E] min-h-full pb-[120px]">
                                <div className="flex items-center justify-between px-4 h-[44px] text-[#FBDEB2]">
                                    <span role="button" onClick={(e) => this.checkurl(e, "/deposit")} className="cursor-pointer text-xl">‹</span>
                                    <span className="text-sm">แจ้งสลิป</span>
                                    <span className="w-4"></span>
                                </div>
                                {/* อัพโหลดสลิป เท่านั้น */}
                                <div className="mx-4 mt-4">
                                    <div className="text-[#FBDEB2] text-sm mb-2">แนบสลิปโอนเงิน</div>
                                    <label htmlFor="slipfileinput" className="block rounded-xl border border-dashed border-[#8A7349] bg-[#00000040] cursor-pointer overflow-hidden">
                                        {this.state.previewUrl ? (
                                            <img src={this.state.previewUrl} alt="slip" className="w-full max-h-[320px] object-contain" />
                                        ) : (
                                            <div className="flex flex-col items-center justify-center py-16">
                                                <div className="text-4xl">📎</div>
                                                <div className="text-[#CDCDCD] text-xs mt-2">แตะเพื่อเลือกรูปสลิป</div>
                                            </div>
                                        )}
                                        <input id="slipfileinput" type="file" accept="image/*" style={{ display: 'none' }} onChange={this.handleFileSelectedt} />
                                    </label>
                                </div>
                                <div className="mx-4 mt-5">
                                    <button
                                        onClick={() => { if (!this.state.files || this.state.files.length === 0) { this.notify && this.notify('warning', 'กรุณาแนบสลิปก่อน'); return; } this.uploadSlip(); }}
                                        className="rounded-xl w-full h-[48px] flex items-center justify-center font-semibold"
                                        style={{ color: 'black', background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)', border: '1px solid #ECCA77' }}
                                    >
                                        <span className="text-[14px] font-semibold">แจ้งสลิป</span>
                                    </button>
                                </div>
                                <div className="mx-4 mt-6">
                                    <div className="text-sm mb-2 font-bold" style={{ color: '#ECCA77' }}>คำแนะนำ</div>
                                    {[
                                        'โอนเงินแล้วแนบสลิปการโอนให้ชัดเจน',
                                        'ระบบจะตรวจสอบและเติมเครดิตให้โดยเร็วที่สุด',
                                    ].map((t, i) => (
                                        <div key={i} className="flex items-start mb-2">
                                            <span className="mr-2 flex-shrink-0" style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginTop: 6 }}></span>
                                            <span className="text-[#CDCDCD] text-sm">{t}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            );
                        })()}
                        {this.state.tabselect === 33 && (
                            <Luckywhell
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => { if (e?.preventDefault) e.preventDefault(); this.checkurl(e, to); }}
                            />
                        )}
                        {this.state.tabselect === 36 && (
                            <Checkindaily
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                onNavigate={(to, e) => { if (e?.preventDefault) e.preventDefault(); this.checkurl(e, to); }}
                            />
                        )}
                        {this.state.tabselect === 37 && (
                            <Cardminigame
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => { if (e?.preventDefault) e.preventDefault(); this.checkurl(e, to); }}
                            />
                        )}
                    </div>
                    <section
                        data-v-70c7d421=""
                        className="bottom-nav nav-bg mx-auto max-w-[438px]"
                        style={{ backgroundImage: "url(/idea-bet.live/theme/ufa7/images/nav-bottom-with-play.webp)" }}
                    >
                        <div data-v-70c7d421="" className="relative">
                            <div
                                data-v-70c7d421=""
                                className="grid grid-cols-5 absolute top-[4em] w-full h-[300px]"
                            >
                                <a
                                    data-v-70c7d421=""
                                    aria-current="page"
                                    role="button" onClick={(e) => this.checkurl(e, "/home")}
                                    className="router-link-active router-link-exact-active b-nav-item"
                                >
                                    <img
                                        data-v-70c7d421=""
                                        className="bottom-nav-image cursor-pointer"
                                        src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-home-on.svg"
                                        alt="หน้าหลัก"
                                    />
                                    <div
                                        data-v-70c7d421=""
                                        className="mt-1 text-[10px] capitalize"
                                        style={{ opacity: 1, color: '#ECCA77' }}
                                    >
                                        หน้าหลัก
                                    </div>
                                </a>
                                <a data-v-70c7d421="" role="button" onClick={(e) => this.checkurl(e, "/deposit")} className="b-nav-item">
                                    <img
                                        data-v-70c7d421=""
                                        className="bottom-nav-image cursor-pointer"
                                        src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-funds.svg"
                                        alt="ฝาก/ถอน"
                                    />
                                    <div
                                        data-v-70c7d421=""
                                        className="mt-1 text-[10px] capitalize"
                                        style={{ opacity: "0.7", color: '#ECCA77' }}
                                    >
                                        ฝาก/ถอน
                                    </div>
                                </a>
                                <a data-v-70c7d421="" role="button" onClick={(e) => this.playMainGame(e)} className="b-nav-item">
                                    {/**/}
                                    <div
                                        data-v-70c7d421=""
                                        className="pt-8 text-[10px] capitalize cursor-pointer"
                                        style={{ opacity: "0.7", color: '#ECCA77' }}
                                    >
                                        เข้าเล่น
                                    </div>
                                </a>
                                <a data-v-70c7d421="" role="button" onClick={(e) => this.checkurl(e, "/promotion")} className="b-nav-item">
                                    <img data-v-70c7d421="" className="bottom-nav-image cursor-pointer" src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-rewards.svg" alt="โปรโมชั่น" />
                                    <div data-v-70c7d421="" className="mt-1 text-[10px] capitalize" style={{ opacity: "0.7", color: '#ECCA77' }}>โปรโมชั่น</div>
                                </a>
                                <a data-v-70c7d421="" role="button" onClick={(e) => this.checkurl(e, "/history")} className="b-nav-item">
                                    <img
                                        data-v-70c7d421=""
                                        className="bottom-nav-image cursor-pointer"
                                        src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-history.svg"
                                        alt="ประวัติ"
                                    />
                                    <div
                                        data-v-70c7d421=""
                                        className="mt-1 text-[10px] capitalize"
                                        style={{ opacity: "0.7", color: '#ECCA77' }}
                                    >
                                        ประวัติ
                                    </div>
                                </a>
                                <a data-v-70c7d421="" role="button" onClick={(e) => this.checkurl(e, "/profile")} className="b-nav-item">
                                    <img
                                        data-v-70c7d421=""
                                        className="bottom-nav-image cursor-pointer"
                                        src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-profiles.svg"
                                        alt="โปรไฟล์"
                                    />
                                    <div
                                        data-v-70c7d421=""
                                        className="mt-1 text-[10px] capitalize"
                                        style={{ opacity: "0.7", color: '#ECCA77' }}
                                    >
                                        โปรไฟล์
                                    </div>
                                </a>
                            </div>
                            <div
                                data-v-70c7d421=""
                                role="button"
                                onClick={(e) => this.playMainGame(e)}
                                className="absolute left-1/2 transform -translate-x-1/2 cursor-pointer"
                                style={{ zIndex: 10, top: 20, width: 80, height: 220 }}
                            />
                        </div>
                    </section>
                </div>


                {/* <div className={this.state.modalx ? "overlay active" : "overlay "}></div> */}
            </>
        );
    }
}

export default Main;
